[
  "InlineAPIVersionOutput",
  "InlineGetDynamicShadowConfigOperation",
  "InlineGetDynamicShadowConfigOutput",
  "InlineGreetingOutput",
  "InlineRetrieveUserPermissionsOutput",
  "V2AccountsAccountLink",
  "V2AccountsAccountLinkUseCase",
  "V2AccountsAccountOnboarding",
  "V2AccountsAccountOnboardingCollectionOptions",
  "V2AccountsAccountSessionCreateComponentsAccountConfigResource",
  "V2AccountsAccountSessionCreateComponentsAccountConfigScopes",
  "V2AccountsAccountSessionCreateComponentsBaseConfigResource",
  "V2AccountsAccountSessionCreateComponentsPaymentsConfigResource",
  "V2AccountsAccountSessionCreateComponentsPaymentsConfigScopes",
  "V2AccountsAccountSessionCreateComponentsPayoutsConfigResource",
  "V2AccountsAccountSessionCreateComponentsPayoutsConfigScopes",
  "V2AccountsAccountSessionCreateComponentsResource",
  "V2AccountsAccountSupport",
  "V2AccountsAccountUpdate",
  "V2AccountsAccountUpdateCollectionOptions",
  "V2AccountsAddress",
  "V2AccountsAddressResource",
  "V2AccountsAttestationsResource",
  "V2AccountsAutoRespond",
  "V2AccountsAutomaticIndirectTaxResource",
  "V2AccountsBacsDebitPaymentsResource",
  "V2AccountsBankAccountsCapabilityResource",
  "V2AccountsBankAccountsFeatureResource",
  "V2AccountsBillingResource",
  "V2AccountsBranding",
  "V2AccountsBusinessAdditionalAddressResource",
  "V2AccountsBusinessDetailsAnnualRevenueResource",
  "V2AccountsBusinessDetailsIdNumberResource",
  "V2AccountsBusinessDetailsMonthlyRevenueResource",
  "V2AccountsBusinessDetailsRegistrationDateResource",
  "V2AccountsBusinessDetailsResource",
  "V2AccountsBusinessDetailsScriptAddressResource",
  "V2AccountsBusinessDetailsScriptNamesResource",
  "V2AccountsBusinessDetailsVerificationResource",
  "V2AccountsBusinessScriptNameResource",
  "V2AccountsCapabilityProtectionResource",
  "V2AccountsCapabilityProtections",
  "V2AccountsCapabilityResource",
  "V2AccountsCapabilityStatusDetail",
  "V2AccountsCardCreatorCapabilitiesResource",
  "V2AccountsCardCreatorCapabilitiesResourceCommercial",
  "V2AccountsCardCreatorCapabilitiesResourceCommercialCeltic",
  "V2AccountsCardCreatorCapabilitiesResourceCommercialCrossRiverBank",
  "V2AccountsCardCreatorCapabilitiesResourceCommercialFifthThird",
  "V2AccountsCardCreatorCapabilitiesResourceCommercialLead",
  "V2AccountsCardCreatorCapabilitiesResourceCommercialStripe",
  "V2AccountsCardCreatorCapabilitiesResourceConsumer",
  "V2AccountsCardCreatorCapabilitiesResourceConsumerCeltic",
  "V2AccountsCardCreatorCapabilitiesResourceConsumerCrossRiverBank",
  "V2AccountsCardCreatorCapabilitiesResourceConsumerLead",
  "V2AccountsCardCreatorConfigResource",
  "V2AccountsCardCreatorTosAcceptanceResource",
  "V2AccountsCardCreatorTosAcceptancesResource",
  "V2AccountsCardCreatorTosAcceptancesResourceCommercial",
  "V2AccountsCardCreatorTosAcceptancesResourceCommercialCeltic",
  "V2AccountsCardCreatorTosAcceptancesResourceCommercialCelticChargeCard",
  "V2AccountsCardCreatorTosAcceptancesResourceCommercialCelticSpendCard",
  "V2AccountsCardCreatorTosAcceptancesResourceCommercialCrossRiverBank",
  "V2AccountsCardCreatorTosAcceptancesResourceCommercialCrossRiverBankChargeCard",
  "V2AccountsCardCreatorTosAcceptancesResourceCommercialCrossRiverBankPrepaidCard",
  "V2AccountsCardCreatorTosAcceptancesResourceCommercialCrossRiverBankSpendCard",
  "V2AccountsCardCreatorTosAcceptancesResourceCommercialFifthThird",
  "V2AccountsCardCreatorTosAcceptancesResourceCommercialLead",
  "V2AccountsCardCreatorTosAcceptancesResourceCommercialLeadPrepaidCard",
  "V2AccountsCardCreatorTosAcceptancesResourceConsumer",
  "V2AccountsCardCreatorTosAcceptancesResourceConsumerCeltic",
  "V2AccountsCardCreatorTosAcceptancesResourceConsumerCelticRevolvingCreditCard",
  "V2AccountsCardCreatorTosAcceptancesResourceConsumerCrossRiverBank",
  "V2AccountsCardCreatorTosAcceptancesResourceConsumerCrossRiverBankPrepaidCard",
  "V2AccountsCardCreatorTosAcceptancesResourceConsumerLead",
  "V2AccountsCardCreatorTosAcceptancesResourceConsumerLeadDebitCard",
  "V2AccountsCardCreatorTosAcceptancesResourceConsumerLeadPrepaidCard",
  "V2AccountsCardPayments",
  "V2AccountsCardholderCapabilitiesResource",
  "V2AccountsCardholderCapabilitiesResourceCommercial",
  "V2AccountsCardholderCapabilitiesResourceCommercialCeltic",
  "V2AccountsCardholderCapabilitiesResourceCommercialCelticChargeCard",
  "V2AccountsCardholderCapabilitiesResourceCommercialCelticSpendCard",
  "V2AccountsCardholderCapabilitiesResourceCommercialCrossRiverBank",
  "V2AccountsCardholderCapabilitiesResourceCommercialCrossRiverBankChargeCard",
  "V2AccountsCardholderCapabilitiesResourceCommercialCrossRiverBankPrepaidCard",
  "V2AccountsCardholderCapabilitiesResourceCommercialCrossRiverBankSpendCard",
  "V2AccountsCardholderCapabilitiesResourceCommercialFifthThird",
  "V2AccountsCardholderCapabilitiesResourceCommercialFifthThirdChargeCard",
  "V2AccountsCardholderCapabilitiesResourceCommercialLead",
  "V2AccountsCardholderCapabilitiesResourceCommercialLeadPrepaidCard",
  "V2AccountsCardholderCapabilitiesResourceCommercialSutton",
  "V2AccountsCardholderCapabilitiesResourceCommercialSuttonPrepaidCard",
  "V2AccountsCardholderCapabilitiesResourceConsumer",
  "V2AccountsCardholderCapabilitiesResourceConsumerCeltic",
  "V2AccountsCardholderCapabilitiesResourceConsumerCelticRevolvingCreditCard",
  "V2AccountsCardholderCapabilitiesResourceConsumerCrossRiverBank",
  "V2AccountsCardholderCapabilitiesResourceConsumerCrossRiverBankPrepaidCard",
  "V2AccountsCardholderCapabilitiesResourceConsumerLead",
  "V2AccountsCardholderCapabilitiesResourceConsumerLeadPrepaidCard",
  "V2AccountsCardholderConfigResource",
  "V2AccountsCardholderSpendControlsResource",
  "V2AccountsCardholderSpendingLimitResource",
  "V2AccountsCardholderTosAcceptanceResource",
  "V2AccountsCardholderTosAcceptancesResource",
  "V2AccountsConfigurationResource",
  "V2AccountsContact",
  "V2AccountsCustomField",
  "V2AccountsCustomerCapabilitiesResource",
  "V2AccountsCustomerConfigResource",
  "V2AccountsCustomerFeaturesResource",
  "V2AccountsDeclineOn",
  "V2AccountsDefaultsResource",
  "V2AccountsDeveloperCapabilitiesResource",
  "V2AccountsDeveloperConfigResource",
  "V2AccountsDirectAccount",
  "V2AccountsDirectAccountConfigurationResource",
  "V2AccountsDirectAccountDefaultsResource",
  "V2AccountsDirectAccountRequirementsEntryCapabilityRestrictionResource",
  "V2AccountsDirectAccountRequirementsEntryImpactResource",
  "V2AccountsDirectAccountRequirementsEntryResourceV3",
  "V2AccountsDirectAccountRequirementsResource",
  "V2AccountsDirectorshipDeclarationResource",
  "V2AccountsDocumentsResource",
  "V2AccountsFeatureResource",
  "V2AccountsFeatureStatusDetail",
  "V2AccountsFrontBackResource",
  "V2AccountsFutureRequirementsResource",
  "V2AccountsGraphAbstractionsAddWorkspacesToAccountGroupResponse",
  "V2AccountsGraphAbstractionsCreateAccountGroupResponse",
  "V2AccountsGraphAbstractionsDeleteAccountGroupResponse",
  "V2AccountsGraphAbstractionsDismissResourceSharingEligibilityCheckResponse",
  "V2AccountsGraphAbstractionsGroupConfig",
  "V2AccountsGraphAbstractionsListAllAccountGroupsByWorkspaceMemberResponse",
  "V2AccountsGraphAbstractionsListAllAccountGroupsOwnedByCompartmentResponse",
  "V2AccountsGraphAbstractionsListEligibleWorkspacesForAccountGroupResponse",
  "V2AccountsGraphAbstractionsListResourceSharingEligibilityCheckStatusResponse",
  "V2AccountsGraphAbstractionsRemoveWorkspacesFromAccountGroupResponse",
  "V2AccountsGraphAbstractionsResourceSharingConfig",
  "V2AccountsGraphAbstractionsResourceSharingEligibilityCheckResult",
  "V2AccountsGraphAbstractionsRunResourceSharingEligibilityCheckResponse",
  "V2AccountsGraphAbstractionsUpdateAccountGroupResponse",
  "V2AccountsGraphAbstractionsV1AccountIds",
  "V2AccountsGrossSettlementResource",
  "V2AccountsIdentityDefaultsResource",
  "V2AccountsIdentityTosAcceptancesResource",
  "V2AccountsInvoicingResource",
  "V2AccountsKonbiniPayments",
  "V2AccountsKonbiniPaymentsSupport",
  "V2AccountsKonbiniPaymentsSupportHours",
  "V2AccountsListAccountsResponse",
  "V2AccountsListPersonsDirectAccountResponse",
  "V2AccountsListPersonsResponse",
  "V2AccountsMerchantCapabilitiesResource",
  "V2AccountsMerchantConfigResource",
  "V2AccountsMerchantFeaturesResource",
  "V2AccountsMoneyManagerCapabilitiesResource",
  "V2AccountsMoneyManagerCapabilitiesResourceBusinessCustodialStorage",
  "V2AccountsMoneyManagerCapabilitiesResourceBusinessCustodialStorageInbound",
  "V2AccountsMoneyManagerCapabilitiesResourceBusinessCustodialStorageOutbound",
  "V2AccountsMoneyManagerCapabilitiesResourceBusinessSavings",
  "V2AccountsMoneyManagerCapabilitiesResourceBusinessSavingsInbound",
  "V2AccountsMoneyManagerCapabilitiesResourceBusinessSavingsOutbound",
  "V2AccountsMoneyManagerCapabilitiesResourceBusinessStorage",
  "V2AccountsMoneyManagerCapabilitiesResourceBusinessStorageInbound",
  "V2AccountsMoneyManagerCapabilitiesResourceBusinessStorageOutbound",
  "V2AccountsMoneyManagerCapabilitiesResourceConsumerStorage",
  "V2AccountsMoneyManagerCapabilitiesResourceConsumerStorageInbound",
  "V2AccountsMoneyManagerCapabilitiesResourceConsumerStorageOutbound",
  "V2AccountsMoneyManagerCapabilitiesResourceInboundTransfers",
  "V2AccountsMoneyManagerCapabilitiesResourceOutboundPayments",
  "V2AccountsMoneyManagerCapabilitiesResourceOutboundTransfers",
  "V2AccountsMoneyManagerCapabilitiesResourceReceivedCredits",
  "V2AccountsMoneyManagerCapabilitiesResourceReceivedDebits",
  "V2AccountsMoneyManagerConfigResource",
  "V2AccountsOwnershipDeclarationResource",
  "V2AccountsPayPayPayments",
  "V2AccountsPayoutMethodDefaults",
  "V2AccountsPersonAdditionalAddressResource",
  "V2AccountsPersonAdditionalNameResource",
  "V2AccountsPersonDateOfBirthResource",
  "V2AccountsPersonDocumentResource",
  "V2AccountsPersonIdNumberResource",
  "V2AccountsPersonRelationshipResource",
  "V2AccountsPersonScriptAddressResource",
  "V2AccountsPersonScriptNameResource",
  "V2AccountsPersonTosAcceptancesResource",
  "V2AccountsPersonsProvidedResource",
  "V2AccountsPrimarySecondaryVerificationResource",
  "V2AccountsProfileResource",
  "V2AccountsRecipientCapabilitiesResource",
  "V2AccountsRecipientConfigResource",
  "V2AccountsRecipientFeaturesResource",
  "V2AccountsRecipientOnboarding",
  "V2AccountsRecipientOnboardingCollectionOptions",
  "V2AccountsRecipientUpdate",
  "V2AccountsRecipientUpdateCollectionOptions",
  "V2AccountsRegulatedActivityResource",
  "V2AccountsRelatedNetworkObject",
  "V2AccountsRendering",
  "V2AccountsRepresentativeDeclarationResource",
  "V2AccountsRequirementsAlternativeCapabilityRestrictionResource",
  "V2AccountsRequirementsAlternativeEntryResource",
  "V2AccountsRequirementsAlternativeImpactResource",
  "V2AccountsRequirementsAlternativeOptionResource",
  "V2AccountsRequirementsAlternativeOriginalEntryResource",
  "V2AccountsRequirementsAlternativeResource",
  "V2AccountsRequirementsEntryCapabilityRestrictionResource",
  "V2AccountsRequirementsEntryDeadlineResource",
  "V2AccountsRequirementsEntryErrorResource",
  "V2AccountsRequirementsEntryFeatureRestrictionResource",
  "V2AccountsRequirementsEntryImpactResource",
  "V2AccountsRequirementsEntryPayoutsRestrictionResource",
  "V2AccountsRequirementsEntryReasonResourceV3",
  "V2AccountsRequirementsEntryReferenceResource",
  "V2AccountsRequirementsEntryResourceV3",
  "V2AccountsRequirementsResourceV3",
  "V2AccountsResponsibilitiesResource",
  "V2AccountsRoutingAccountLink",
  "V2AccountsRoutingAccountLinkInternal",
  "V2AccountsRoutingAccountLinkUseCase",
  "V2AccountsRoutingAccountOnboarding",
  "V2AccountsRoutingAccountUpdate",
  "V2AccountsRoutingAddress",
  "V2AccountsRoutingBankAccountsContainerResource",
  "V2AccountsRoutingBusinessProfileResource",
  "V2AccountsRoutingChallengeSecretRequired",
  "V2AccountsRoutingCommunicationSettings",
  "V2AccountsRoutingConfigurationResource",
  "V2AccountsRoutingContact",
  "V2AccountsRoutingCustomerConfigurationResource",
  "V2AccountsRoutingDateOfBirthResource",
  "V2AccountsRoutingExpiredResponse",
  "V2AccountsRoutingFeatureConfigs",
  "V2AccountsRoutingFeatureResource",
  "V2AccountsRoutingFeatureStatusDetail",
  "V2AccountsRoutingFeaturesResource",
  "V2AccountsRoutingGeneratedNewEmailResponse",
  "V2AccountsRoutingLegalEntityAddressResource",
  "V2AccountsRoutingLegalEntityDefaultsResource",
  "V2AccountsRoutingLegalEntityIdNumberResource",
  "V2AccountsRoutingLegalEntityRepresentativeIdNumberResource",
  "V2AccountsRoutingLegalEntityRepresentativeResource",
  "V2AccountsRoutingLegalEntityRepresentativeScriptNameResource",
  "V2AccountsRoutingLegalEntityScriptAddressResource",
  "V2AccountsRoutingLegalEntityScriptNameResource",
  "V2AccountsRoutingLegalEntityScriptNamesResource",
  "V2AccountsRoutingLegalEntityTosAcceptanceResource",
  "V2AccountsRoutingMerchantConfigFeaturesResource",
  "V2AccountsRoutingMerchantConfigurationResource",
  "V2AccountsRoutingRecipientActionFilterCount",
  "V2AccountsRoutingRecipientConfigurationResource",
  "V2AccountsRoutingRecipientCountryFilterCount",
  "V2AccountsRoutingRecipientFeatureConfigs",
  "V2AccountsRoutingRelatedNetworkObject",
  "V2AccountsRoutingRequirementDeadlineResource",
  "V2AccountsRoutingRequirementErrorResource",
  "V2AccountsRoutingRequirementImpactResource",
  "V2AccountsRoutingRequirementResource",
  "V2AccountsRoutingRoutingCompleteAccountLinkResponse",
  "V2AccountsRoutingRoutingConsumeAccountLinkResponse",
  "V2AccountsRoutingRoutingListAccountInternalResourcesResponse",
  "V2AccountsRoutingRoutingListAccountsResponse",
  "V2AccountsRoutingRoutingRetrieveAccountCommunicationSettingsResponse",
  "V2AccountsRoutingRoutingRetrieveAccountFeatureConfigsResponse",
  "V2AccountsRoutingRoutingRetrieveAccountLinkUrlsInternalResponse",
  "V2AccountsRoutingRoutingRetrieveKYCProjectionByCompartmentGQLResponse",
  "V2AccountsRoutingRoutingSearchAccountInternalResourcesResponse",
  "V2AccountsRoutingRoutingSearchRecipientsInternalActionFilterCountsResponse",
  "V2AccountsRoutingRoutingSearchRecipientsInternalCountryFilterCountsResponse",
  "V2AccountsRoutingRoutingSearchRecipientsInternalResponse",
  "V2AccountsRoutingRoutingUpdateAccountCommunicationSettingsResponse",
  "V2AccountsRoutingRoutingUpdateAccountFeatureConfigsResponse",
  "V2AccountsRoutingScriptNameResource",
  "V2AccountsRoutingSupportableFeaturesResource",
  "V2AccountsRoutingValidUatResponse",
  "V2AccountsScriptNameResource",
  "V2AccountsScriptStatementDescriptor",
  "V2AccountsSepaDebitPaymentsResource",
  "V2AccountsSignerPerson",
  "V2AccountsSignerResource",
  "V2AccountsSmartDisputes",
  "V2AccountsStatementDescriptor",
  "V2AccountsStripeBalanceCapabilityResource",
  "V2AccountsStripeBalanceFeatureResource",
  "V2AccountsStripeBalancePayoutsOnlyCapabilityResource",
  "V2AccountsSummary",
  "V2AccountsSummaryMinimumDeadline",
  "V2AccountsSupport",
  "V2AccountsTaxLocation",
  "V2AccountsTosAcceptance",
  "V2AccountsVTwoAccountLink",
  "V2AccountsVTwoAccountLinkUseCase",
  "V2AccountsVTwoAccountOnboarding",
  "V2AccountsVTwoAccountUpdate",
  "V2AccountsVTwoAddress",
  "V2AccountsVTwoBankAccountsContainerResource",
  "V2AccountsVTwoBusinessProfileResource",
  "V2AccountsVTwoConfigurationResource",
  "V2AccountsVTwoContact",
  "V2AccountsVTwoCustomerConfigurationResource",
  "V2AccountsVTwoDateOfBirthResource",
  "V2AccountsVTwoFeatureResource",
  "V2AccountsVTwoFeatureStatusDetail",
  "V2AccountsVTwoFeaturesResource",
  "V2AccountsVTwoLegalEntityAddressResource",
  "V2AccountsVTwoLegalEntityDefaultsResource",
  "V2AccountsVTwoLegalEntityIdNumberResource",
  "V2AccountsVTwoLegalEntityRepresentativeIdNumberResource",
  "V2AccountsVTwoLegalEntityRepresentativeResource",
  "V2AccountsVTwoLegalEntityRepresentativeScriptNameResource",
  "V2AccountsVTwoLegalEntityScriptAddressResource",
  "V2AccountsVTwoLegalEntityScriptNameResource",
  "V2AccountsVTwoLegalEntityScriptNamesResource",
  "V2AccountsVTwoLegalEntityTosAcceptanceResource",
  "V2AccountsVTwoListAccountsResponse",
  "V2AccountsVTwoMerchantConfigFeaturesResource",
  "V2AccountsVTwoMerchantConfigurationResource",
  "V2AccountsVTwoRecipientConfigurationResource",
  "V2AccountsVTwoRelatedNetworkObject",
  "V2AccountsVTwoRequirementDeadlineResource",
  "V2AccountsVTwoRequirementErrorResource",
  "V2AccountsVTwoRequirementImpactResource",
  "V2AccountsVTwoRequirementResource",
  "V2AccountsVTwoScriptNameResource",
  "V2AccountsVTwoSupportableFeaturesResource",
  "V2AccountsValuesEntry",
  "V2AcfAssoc",
  "V2AcfDataEntry",
  "V2AcfEnsureAuthChallengeResponse",
  "V2AcfFlatSchema",
  "V2AcfInitiateUserChallengeResponse",
  "V2AcfRequireUserChallengeResponse",
  "V2AcfRestricted",
  "V2AcfRestrictionsEntry",
  "V2AcfUiDataEntry",
  "V2AcfV2AccountInitiateUserChallengeResponse",
  "V2AcfV2AccountRequireUserChallengeResponse",
  "V2AcfV2AccountValidateUserChallengeResponse",
  "V2AcfValidateUserChallengeResponse",
  "V2ActivityLogsAccountSecurityDetails",
  "V2ActivityLogsActor",
  "V2ActivityLogsAnomalyDetectionSettings",
  "V2ActivityLogsAuthFactor",
  "V2ActivityLogsAuthentication",
  "V2ActivityLogsAuthenticationDetails",
  "V2ActivityLogsDashboardClient",
  "V2ActivityLogsDetails",
  "V2ActivityLogsListActivityLogsResponse",
  "V2ActivityLogsManagedBy",
  "V2ActivityLogsNetwork",
  "V2ActivityLogsRisk",
  "V2ActivityLogsRiskSignal",
  "V2ActivityLogsScimDetails",
  "V2ActivityLogsSsoDetails",
  "V2ActivityLogsUser",
  "V2ActivityLogsUserAccessDetails",
  "V2ActivityLogsUserInviteDetails",
  "V2ActivityLogsUserProfileDetails",
  "V2ActivityLogsUserRoleDetails",
  "V2AdjustmentsPublicAdjustedFlowDetails",
  "V2AdjustmentsPublicCreateTestAdjustmentResponse",
  "V2AdjustmentsPublicListAdjustmentsResponse",
  "V2AgenticSellersAddress",
  "V2AgenticSellersAdjustmentEvent",
  "V2AgenticSellersBuyer",
  "V2AgenticSellersCreateOrderEventResponse",
  "V2AgenticSellersFulfillmentDetails",
  "V2AgenticSellersFulfillmentEvent",
  "V2AgenticSellersLink",
  "V2AgenticSellersListOrdersResponse",
  "V2AgenticSellersMessage",
  "V2AgenticSellersMessageError",
  "V2AgenticSellersMessageInfo",
  "V2AgenticSellersPaymentProvider",
  "V2AgenticSellersReceivedCheckoutSessionAddress",
  "V2AgenticSellersReceivedCheckoutSessionAffiliateAttribution",
  "V2AgenticSellersReceivedCheckoutSessionAffiliateAttributionSource",
  "V2AgenticSellersReceivedCheckoutSessionAgentDetails",
  "V2AgenticSellersReceivedCheckoutSessionBuyer",
  "V2AgenticSellersReceivedCheckoutSessionBuyerConsents",
  "V2AgenticSellersReceivedCheckoutSessionClientDeviceMetadataDetails",
  "V2AgenticSellersReceivedCheckoutSessionContact",
  "V2AgenticSellersReceivedCheckoutSessionCustomAttribute",
  "V2AgenticSellersReceivedCheckoutSessionDisclosure",
  "V2AgenticSellersReceivedCheckoutSessionFulfillmentDetails",
  "V2AgenticSellersReceivedCheckoutSessionLink",
  "V2AgenticSellersReceivedCheckoutSessionMarketing",
  "V2AgenticSellersReceivedCheckoutSessionMarketingConsent",
  "V2AgenticSellersReceivedCheckoutSessionMarketingOptions",
  "V2AgenticSellersReceivedCheckoutSessionMessage",
  "V2AgenticSellersReceivedCheckoutSessionPaymentProvider",
  "V2AgenticSellersReceivedCheckoutSessionRiskDetails",
  "V2AgenticSellersReceivedCheckoutSessionSelectedFulfillmentOption",
  "V2AgenticSellersReceivedCheckoutSessionShippingDetails",
  "V2AgenticSellersReceivedCheckoutSessionTotal",
  "V2AgenticSellersSelectedDigitalFulfillmentOption",
  "V2AgenticSellersSelectedFulfillmentOption",
  "V2AgenticSellersSelectedShippingFulfillmentOption",
  "V2AgenticSellersSharedMetadataEntry",
  "V2AgenticSellersTotal",
  "V2AgenticSellersUcpBuyer",
  "V2AgenticSellersUcpCardDisplay",
  "V2AgenticSellersUcpCheckoutResponseMetadata",
  "V2AgenticSellersUcpFulfillment",
  "V2AgenticSellersUcpFulfillmentAvailableMethod",
  "V2AgenticSellersUcpLink",
  "V2AgenticSellersUcpMessage",
  "V2AgenticSellersUcpPaymentRequest",
  "V2AgenticSellersUcpPostalAddress",
  "V2AgenticSellersUcpTokenCredential",
  "V2AgenticSellersUcpTokenizeResponse",
  "V2AgenticSellersUcpTotal",
  "V2AgreementAgreementConsideration",
  "V2AgreementAgreementCustomer",
  "V2AgreementAgreementDeliverable",
  "V2AgreementAgreementDeliveryTerms",
  "V2AgreementAgreementLineItem",
  "V2AgreementDateOrTime",
  "V2AgreementDateOrTimeRange",
  "V2AgreementQualifiersEntry",
  "V2AgreementQuantity",
  "V2AgreementReferenceId",
  "V2AgreementsPong",
  "V2Amount",
  "V2AnalyticsDimensionsEntry",
  "V2AnalyticsLayerCompileAnalyticsLayerQueryResponse",
  "V2AnalyticsLayerDimension",
  "V2AnalyticsLayerDimensionDocumentation",
  "V2AnalyticsLayerDimensionPresentation",
  "V2AnalyticsLayerGranularityMappingEntry",
  "V2AnalyticsLayerListViewsResponse",
  "V2AnalyticsLayerMeasure",
  "V2AnalyticsLayerMeasureDocumentation",
  "V2AnalyticsLayerMeasureGovernance",
  "V2AnalyticsLayerMeasurePresentation",
  "V2AnalyticsLayerPinotConfig",
  "V2AnalyticsLayerPreAggregation",
  "V2AnalyticsLayerPreAggregationBootstrap",
  "V2AnalyticsLayerPreAggregationIncremental",
  "V2AnalyticsLayerSparkConfigEntry",
  "V2AnalyticsLayerView",
  "V2AnalyticsLayerViewDocumentation",
  "V2AnalyticsLayerViewGovernance",
  "V2AnalyticsLayerViewIdentity",
  "V2AnalyticsLayerViewPresentation",
  "V2AnalyticsLayerVirtualViewInfo",
  "V2AnalyticsMetricQueryValue",
  "V2ApprovalHubManagerApproval",
  "V2ApprovalHubManagerCancelInflightApprovalsResponse",
  "V2ApprovalHubManagerCreateApprovalResponse",
  "V2ApprovalHubManagerSaga",
  "V2ApprovalRequestsApprovalRequestActorUser",
  "V2ApprovalRequestsApprovalRequestApprovedStatusDetails",
  "V2ApprovalRequestsApprovalRequestExecutionFailedStatusDetails",
  "V2ApprovalRequestsApprovalRequestExecutionSucceededStatusDetails",
  "V2ApprovalRequestsApprovalRequestFailedStatusDetails",
  "V2ApprovalRequestsApprovalRequestRejectedStatusDetails",
  "V2ApprovalRequestsApprovalRequestRequestedBy",
  "V2ApprovalRequestsApprovalRequestReviewedBy",
  "V2ApprovalRequestsApprovalRequestStatusDetails",
  "V2ApprovalRequestsApprovalRequestStatusTransitions",
  "V2ApprovalRequestsApprovalRequestSucceededStatusDetails",
  "V2ApprovalRequestsListApprovalRequestsResponse",
  "V2ApprovalRequestsReview",
  "V2ApprovalRequestsRule",
  "V2AuthPolicyComputeMfaResponse",
  "V2AuthPolicyMfaPolicy",
  "V2AuthPolicyMfaPolicyWithCompartment",
  "V2AuthPolicyRetrieveTeamManagementBehaviorResponse",
  "V2AuthPolicyUpsertMfaResponse",
  "V2BalanceExchangeBalance",
  "V2BalanceExchangeExchange",
  "V2BalanceExchangeExchangeMoneyMovementAmounts",
  "V2BalanceExchangeExchangeStatusTransitions",
  "V2BalanceExchangeListBalanceExchangesResponse",
  "V2BatchPublicEndpointsBatchJobBatchFailedStatusDetails",
  "V2BatchPublicEndpointsBatchJobDefaultStatusDetails",
  "V2BatchPublicEndpointsBatchJobInProgressStatusDetails",
  "V2BatchPublicEndpointsBatchJobOutputFile",
  "V2BatchPublicEndpointsBatchJobReadyForUploadStatusDetails",
  "V2BatchPublicEndpointsBatchJobStatusDetails",
  "V2BatchPublicEndpointsBatchJobValidatingStatusDetails",
  "V2BatchPublicEndpointsExternalUrl",
  "V2BatchPublicEndpointsMetadataEntry",
  "V2BillPayAddressResource",
  "V2BillPayBillAutoSchedulePreferences",
  "V2BillPayBillDeliveryOptions",
  "V2BillPayBillManagedBy",
  "V2BillPayBillPaymentOptions",
  "V2BillPayBillStatusTransitions",
  "V2BillPayExtractBillDetailsFailure",
  "V2BillPayExtractBillDetailsResponse",
  "V2BillPayExtractBillDetailsSuccess",
  "V2BillPayExtractedBillDetails",
  "V2BillPayListBillsResponse",
  "V2BillPayPayoutMethodDetails",
  "V2BillPayRecipientDetails",
  "V2BillPaySearchBillsResponse",
  "V2BillingBillingMeterMeterEvent",
  "V2BillingBillingMeterPayloadEntry",
  "V2BillingBillingMeterSingleEventCancellationSettingsV2",
  "V2BillingBillingProfilesListProfilesResponse",
  "V2BillingBillingSettingsAcssDebit",
  "V2BillingBillingSettingsAcssDebitMandateOptions",
  "V2BillingBillingSettingsBancontact",
  "V2BillingBillingSettingsCalculationBillSetting",
  "V2BillingBillingSettingsCard",
  "V2BillingBillingSettingsCardMandateOptions",
  "V2BillingBillingSettingsCustomerBalance",
  "V2BillingBillingSettingsCustomerBalanceBankTransfer",
  "V2BillingBillingSettingsCustomerBalanceEuBankTransfer",
  "V2BillingBillingSettingsEmailDelivery",
  "V2BillingBillingSettingsInvoiceBillSetting",
  "V2BillingBillingSettingsListBillSettingVersionsResponse",
  "V2BillingBillingSettingsListBillSettingsResponse",
  "V2BillingBillingSettingsListCollectionSettingVersionsResponse",
  "V2BillingBillingSettingsListCollectionSettingsResponse",
  "V2BillingBillingSettingsPaymentDue",
  "V2BillingBillingSettingsPaymentMethodOptionsResponse",
  "V2BillingBillingSettingsTaxCalculationBillSetting",
  "V2BillingBillingSettingsTimeUntilDue",
  "V2BillingBillingSettingsUsBankAccountFinancialConnections",
  "V2BillingBillingSettingsUsBankAccountFinancialConnectionsFilters",
  "V2BillingBillingSettingsUsBankAccountOptions",
  "V2BillingContractsBillAt",
  "V2BillingContractsBillSettingsCalculation",
  "V2BillingContractsBillSettingsDetails",
  "V2BillingContractsBillSettingsInvoice",
  "V2BillingContractsBillSettingsTax",
  "V2BillingContractsBillingProfileDetails",
  "V2BillingContractsCollectionSettingsDetails",
  "V2BillingContractsContractBillingCycleAnchor",
  "V2BillingContractsContractBillingSettings",
  "V2BillingContractsContractCollectionStatusTransitions",
  "V2BillingContractsContractOneTimeFeeList",
  "V2BillingContractsContractOneTimeFeeProductDetails",
  "V2BillingContractsContractPriceDetailsCurrencyOption",
  "V2BillingContractsContractPriceDetailsRecurring",
  "V2BillingContractsContractPricingLineList",
  "V2BillingContractsContractPricingLineOverrideList",
  "V2BillingContractsContractPricingLinePriceDetails",
  "V2BillingContractsContractPricingLinePricing",
  "V2BillingContractsContractPricingLinePricingPlanDetails",
  "V2BillingContractsContractPricingLineQuantityChangePricing",
  "V2BillingContractsContractPricingOverrideList",
  "V2BillingContractsContractPricingSegment",
  "V2BillingContractsContractPricingSegmentMultiplyPricing",
  "V2BillingContractsContractPricingSegmentPriceDetails",
  "V2BillingContractsContractPricingSegmentPricingOverride",
  "V2BillingContractsContractPricingSegmentPricingSpec",
  "V2BillingContractsContractPricingSegmentTiers",
  "V2BillingContractsContractProductDetails",
  "V2BillingContractsContractStatusTransitions",
  "V2BillingContractsCreateContractPricingSegmentPreviewResponse",
  "V2BillingContractsCurrencyOptionsEntry",
  "V2BillingContractsEndsAt",
  "V2BillingContractsListContractPricingLineQuantityChangesResponse",
  "V2BillingContractsListContractPricingSegmentsResponse",
  "V2BillingContractsListContractsResponse",
  "V2BillingContractsPricingOverrideAddRate",
  "V2BillingContractsPricingOverrideCriteria",
  "V2BillingContractsPricingOverrideMultiplyPricing",
  "V2BillingContractsPricingOverrideOverwriteLicenseFee",
  "V2BillingContractsPricingOverrideOverwritePrice",
  "V2BillingContractsPricingOverrideOverwriteRate",
  "V2BillingContractsPricingOverrideRemove",
  "V2BillingContractsStartsAt",
  "V2BillingContractsTiersSpec",
  "V2BillingContractsTimeUntilDue",
  "V2BillingContractsTransformQuantity",
  "V2BillingGroupContractAssociation",
  "V2BillingGroupContracts",
  "V2BillingGroupGetMerchantDetailResponse",
  "V2BillingGroupGetOrgResponse",
  "V2BillingGroupListAllGroupsResponse",
  "V2BillingGroupListGroupableMerchantsResponse",
  "V2BillingGroupListPossibleLeadMerchantsResponse",
  "V2BillingMetronomeCreateMetronomeAccountResponse",
  "V2BillingMetronomeIssueMetronomeUserTokenResponse",
  "V2BillingProductCatalogAcssDebit",
  "V2BillingProductCatalogAcssDebitMandateOptions",
  "V2BillingProductCatalogAmountDetailsV2",
  "V2BillingProductCatalogApplyActionEffectiveAt",
  "V2BillingProductCatalogApplyActionResult",
  "V2BillingProductCatalogApplyDiscountActionResult",
  "V2BillingProductCatalogBancontact",
  "V2BillingProductCatalogBillingCadencePayerResponse",
  "V2BillingProductCatalogBillingCadenceSettingsDataBill",
  "V2BillingProductCatalogBillingCadenceSettingsDataCollection",
  "V2BillingProductCatalogBillingCadenceSettingsDataResponse",
  "V2BillingProductCatalogBillingCadenceSettingsResponse",
  "V2BillingProductCatalogBillingCadenceStatusTransitions",
  "V2BillingProductCatalogBillingCycle",
  "V2BillingProductCatalogBillingCycleDay",
  "V2BillingProductCatalogBillingCycleMonth",
  "V2BillingProductCatalogBillingCycleTime",
  "V2BillingProductCatalogBillingCycleWeek",
  "V2BillingProductCatalogBillingCycleYear",
  "V2BillingProductCatalogBillingIntentStatusTransitionsV2",
  "V2BillingProductCatalogBillingPaymentSessionPaymentIntentDetails",
  "V2BillingProductCatalogBillingPaymentSessionSetupIntentDetails",
  "V2BillingProductCatalogBillingProfileDataResponse",
  "V2BillingProductCatalogBulkEditRateCardRatesResponse",
  "V2BillingProductCatalogCadenceDataPayerResponse",
  "V2BillingProductCatalogCadenceDataResponse",
  "V2BillingProductCatalogCadenceDiscountDetailsPercentOff",
  "V2BillingProductCatalogCadenceDiscountDetailsPercentOffMaxApplications",
  "V2BillingProductCatalogCadenceSpendModifierAmount",
  "V2BillingProductCatalogCadenceSpendModifierMaxInvoiceSpend",
  "V2BillingProductCatalogCalculationBillSetting",
  "V2BillingProductCatalogCancellationDetails",
  "V2BillingProductCatalogCancellationDetailsInput",
  "V2BillingProductCatalogCard",
  "V2BillingProductCatalogCardMandateOptions",
  "V2BillingProductCatalogCollectionStatusTransitions",
  "V2BillingProductCatalogComponentConfigurationV2",
  "V2BillingProductCatalogCreditGrantDetails",
  "V2BillingProductCatalogCreditGrantPerTenantDetails",
  "V2BillingProductCatalogCustomerBalance",
  "V2BillingProductCatalogCustomerBalanceBankTransfer",
  "V2BillingProductCatalogCustomerBalanceEuBankTransfer",
  "V2BillingProductCatalogDeactivateActionEffectiveAt",
  "V2BillingProductCatalogDeactivateActionPricingPlanSubscriptionDetailsResult",
  "V2BillingProductCatalogDeactivateActionResult",
  "V2BillingProductCatalogDeactivatePartialPeriodBehaviorOverride",
  "V2BillingProductCatalogDeactivatePartialPeriodBehaviorOverrideLicenseFee",
  "V2BillingProductCatalogDeactivatePricingPlanSubscriptionDetailsOverride",
  "V2BillingProductCatalogDefaultPaymentMethodBehavior",
  "V2BillingProductCatalogDiscountDetail",
  "V2BillingProductCatalogDiscountRuleApplicabilityCriterion",
  "V2BillingProductCatalogDiscountRuleApplicabilityCriterionScope",
  "V2BillingProductCatalogDiscountRuleResult",
  "V2BillingProductCatalogDiscountSource",
  "V2BillingProductCatalogDraftSessionStatusDetails",
  "V2BillingProductCatalogDraftSessionStatusDetailsErrored",
  "V2BillingProductCatalogEditRateCardRatesResponse",
  "V2BillingProductCatalogEmailDelivery",
  "V2BillingProductCatalogIntentInvoiceResources",
  "V2BillingProductCatalogInvoiceBillSetting",
  "V2BillingProductCatalogLicenseFeeComponentDetails",
  "V2BillingProductCatalogListCadenceSpendModifierRulesResponse",
  "V2BillingProductCatalogListCadencesResponse",
  "V2BillingProductCatalogListCustomPricingUnitsResponse",
  "V2BillingProductCatalogListDraftSessionDraftMutationsResponse",
  "V2BillingProductCatalogListDraftSessionDraftObjectsResponse",
  "V2BillingProductCatalogListIntentActionsResponse",
  "V2BillingProductCatalogListIntentsResponse",
  "V2BillingProductCatalogListLicenseFeeVersionsResponse",
  "V2BillingProductCatalogListLicenseFeesResponse",
  "V2BillingProductCatalogListLicensedItemsResponse",
  "V2BillingProductCatalogListMeteredItemsResponse",
  "V2BillingProductCatalogListOneTimeItemsResponse",
  "V2BillingProductCatalogListPackagingConfigurationsResponse",
  "V2BillingProductCatalogListPaymentSessionsResponse",
  "V2BillingProductCatalogListPricingPlanComponentsResponse",
  "V2BillingProductCatalogListPricingPlanSubscriptionsResponse",
  "V2BillingProductCatalogListPricingPlanVersionsResponse",
  "V2BillingProductCatalogListPricingPlansResponse",
  "V2BillingProductCatalogListRateCardCustomPricingUnitOverageRatesResponse",
  "V2BillingProductCatalogListRateCardCustomUnitOverageRatesResponse",
  "V2BillingProductCatalogListRateCardRatesResponse",
  "V2BillingProductCatalogListRateCardSubscriptionsResponse",
  "V2BillingProductCatalogListRateCardVersionsResponse",
  "V2BillingProductCatalogListRateCardsResponse",
  "V2BillingProductCatalogListRecurringCreditGrantVersionsResponse",
  "V2BillingProductCatalogListRecurringCreditGrantsResponse",
  "V2BillingProductCatalogListServiceActionVersionsResponse",
  "V2BillingProductCatalogMaxInvoiceSpend",
  "V2BillingProductCatalogMaxInvoiceSpendAmount",
  "V2BillingProductCatalogMeterSegmentCondition",
  "V2BillingProductCatalogModifyActionEffectiveAt",
  "V2BillingProductCatalogModifyActionPricingPlanSubscriptionDetailsResult",
  "V2BillingProductCatalogModifyActionResult",
  "V2BillingProductCatalogModifyPartialPeriodBehaviorOverride",
  "V2BillingProductCatalogModifyPartialPeriodBehaviorOverrideLicenseFee",
  "V2BillingProductCatalogModifyPartialPeriodBehaviorOverrideRecurringCreditGrant",
  "V2BillingProductCatalogModifyPricingPlanSubscriptionDetailsOverride",
  "V2BillingProductCatalogPaymentDue",
  "V2BillingProductCatalogPaymentMethodOptionsResponse",
  "V2BillingProductCatalogPercentOffConfigResult",
  "V2BillingProductCatalogPercentOffMaxApplications",
  "V2BillingProductCatalogPricingOption",
  "V2BillingProductCatalogPricingPlanComponentDetails",
  "V2BillingProductCatalogPricingPlanSubscriptionComponent",
  "V2BillingProductCatalogPricingPlanSubscriptionComponents",
  "V2BillingProductCatalogRateCardComponentDetails",
  "V2BillingProductCatalogRecurringCreditGrantApplicabilityConfig",
  "V2BillingProductCatalogRecurringCreditGrantApplicabilityScope",
  "V2BillingProductCatalogRecurringCreditGrantComponentDetails",
  "V2BillingProductCatalogRecurringCreditGrantCreditGrant",
  "V2BillingProductCatalogRecurringCreditGrantCreditGrantPerTenant",
  "V2BillingProductCatalogRecurringCreditGrantServiceCycle",
  "V2BillingProductCatalogRemoveActionEffectiveAt",
  "V2BillingProductCatalogRemoveActionResult",
  "V2BillingProductCatalogServiceActionCreditGrantAmount",
  "V2BillingProductCatalogServiceActionCreditGrantApplicabilityConfig",
  "V2BillingProductCatalogServiceActionCreditGrantApplicabilityScope",
  "V2BillingProductCatalogServiceActionCreditGrantDimensionMeterSegmentCondition",
  "V2BillingProductCatalogServiceActionCreditGrantExpiryConfig",
  "V2BillingProductCatalogServiceActionCreditGrantMeterEventFirstPerPeriodCondition",
  "V2BillingProductCatalogServiceActionCreditGrantMeterSegmentCondition",
  "V2BillingProductCatalogServiceActionCreditGrantPerTenantGrantCondition",
  "V2BillingProductCatalogServiceActionCreditGrantPerTenantResponse",
  "V2BillingProductCatalogServiceActionCreditGrantResponse",
  "V2BillingProductCatalogServiceCycle",
  "V2BillingProductCatalogServicingStatusTransitions",
  "V2BillingProductCatalogSubscribeActionEffectiveAt",
  "V2BillingProductCatalogSubscribeActionPricingPlanSubscriptionDetailsResult",
  "V2BillingProductCatalogSubscribeActionResult",
  "V2BillingProductCatalogSubscribeActionV1SubscriptionDetailsResult",
  "V2BillingProductCatalogSubscribeActionV1SubscriptionItemDetailsResult",
  "V2BillingProductCatalogSubscribePartialPeriodBehaviorOverride",
  "V2BillingProductCatalogSubscribePartialPeriodBehaviorOverrideLicenseFee",
  "V2BillingProductCatalogSubscribePartialPeriodBehaviorOverrideRecurringCreditGrant",
  "V2BillingProductCatalogSubscribePricingPlanSubscriptionDetailsOverride",
  "V2BillingProductCatalogTaxCalculationBillSetting",
  "V2BillingProductCatalogTaxDetails",
  "V2BillingProductCatalogTier",
  "V2BillingProductCatalogTiersSpec",
  "V2BillingProductCatalogTimeUntilDue",
  "V2BillingProductCatalogTransformQuantity",
  "V2BillingProductCatalogUpdateRatesResponse",
  "V2BillingProductCatalogUsBankAccountFinancialConnections",
  "V2BillingProductCatalogUsBankAccountFinancialConnectionsFilters",
  "V2BillingProductCatalogUsBankAccountOptions",
  "V2BillingScriptCustomizationsListScriptCustomizationsResponse",
  "V2BillingSpendEventTimePeriod",
  "V2BillingSpendListSpendResponse",
  "V2BillingTransactionBillingTransactionBillsFor",
  "V2BillingTransactionBillingTransactionCustomer",
  "V2BillingTransactionBillingTransactionDiscount",
  "V2BillingTransactionBillingTransactionTax",
  "V2BillingTransactionDateOrTime",
  "V2BillingTransactionDateOrTimeRange",
  "V2BillingTransactionQualifiersEntry",
  "V2BillingTransactionQuantity",
  "V2BillingTransactionReferenceId",
  "V2BusinessNetworkOrchestratedCommerceListOrchestratedCommerceAgreementsResponse",
  "V2BusinessNetworkOrchestratedCommerceOrchestratedCommerceAgreementStatusTransitions",
  "V2BusinessNetworkOrchestratedCommerceOrchestratorDetails",
  "V2BusinessNetworkOrchestratedCommerceSellerDetails",
  "V2BusinessNetworkProfilesBranding",
  "V2BusinessNetworkProfilesImageSizes",
  "V2BusinessNetworkProfilesProfileIndicator",
  "V2BusinessNetworkProfilesSearchNetworkBusinessProfilesResponse",
  "V2CashRewardsCurrentRewardsPeriod",
  "V2CashRewardsGetFinancialAccountRewardsInformationResponse",
  "V2CashRewardsPreviousPeriodsList",
  "V2CashRewardsUpcomingRewardsRate",
  "V2CheckoutFormsFormsEntry",
  "V2CheckoutFormsRetrieveCheckoutFormResponse",
  "V2CheckoutIntegrationsGenerateCheckoutIntegrationIdentifierResponse",
  "V2CheckoutIntegrationsListCheckoutIntegrationsResponse",
  "V2CheckoutIntegrationsUpdateCheckoutIntegrationResponse",
  "V2CheckoutPlansBannerComponent",
  "V2CheckoutPlansCheckboxComponent",
  "V2CheckoutPlansCustomComponent",
  "V2CheckoutPlansDropdownComponent",
  "V2CheckoutPlansDropdownOption",
  "V2CheckoutPlansListCheckoutPlansResponse",
  "V2CheckoutPlansNumericInputComponent",
  "V2CheckoutPlansTextComponent",
  "V2CheckoutPlansTextInputComponent",
  "V2CheckoutPlansUpdateCheckoutPlanResponse",
  "V2CiaCanaryRbBooksDeleteAuthorResponse",
  "V2CommerceAwaitingUploadDetails",
  "V2CommerceCatalogItemAttribute",
  "V2CommerceCatalogItemVariantList",
  "V2CommerceDescription",
  "V2CommerceDownloadUrl",
  "V2CommerceErrorFile",
  "V2CommerceFailedDetails",
  "V2CommerceImage",
  "V2CommerceItemTypeAttributeDefinition",
  "V2CommerceListCatalogItemTypesResponse",
  "V2CommerceListCatalogItemsResponse",
  "V2CommerceListCatalogLocationsResponse",
  "V2CommerceListCatalogPriceBooksResponse",
  "V2CommerceListProductCatalogImportsResponse",
  "V2CommerceLocationAddress",
  "V2CommerceMedia",
  "V2CommerceMetadataEntry",
  "V2CommercePriceBookMarket",
  "V2CommercePriceBookScope",
  "V2CommerceProcessingDetails",
  "V2CommerceProductCatalogImportStatusDetails",
  "V2CommerceSucceededDetails",
  "V2CommerceSucceededWithErrorsDetails",
  "V2CommerceUploadUrl",
  "V2CompartmentKeysKeyNetworkRestrictions",
  "V2CompartmentKeysListCompartmentKeysResponse",
  "V2CompartmentKeysListKeyRestrictionTemplatesResponse",
  "V2CompartmentKeysUpdateKeyRestrictionTemplateForKeyResponse",
  "V2CompartmentsAcceptInviteResponse",
  "V2CompartmentsAccessibleMerchant",
  "V2CompartmentsCheckedUserSandboxManagementActions",
  "V2CompartmentsChildLimits",
  "V2CompartmentsCompartmentLabel",
  "V2CompartmentsCompartmentLimits",
  "V2CompartmentsGetInviteResponse",
  "V2CompartmentsGetInvitedWorkspacesWithinOrganizationResponse",
  "V2CompartmentsGetNearestLivemodeParentCompartmentAttributesResponse",
  "V2CompartmentsGetParentOrganizationAttributesResponse",
  "V2CompartmentsGetUserAccessibleAccountsResponse",
  "V2CompartmentsGetUserAccessibleSandboxesResponse",
  "V2CompartmentsGetUserAccessibleWorkspacesWithinOrganizationResponse",
  "V2CompartmentsGetWorkspaceBrandingSettingsResponse",
  "V2CompartmentsGetWorkspacesEligibleForOrganizationResponse",
  "V2CompartmentsGetWorkspacesWithinOrganizationResponse",
  "V2CompartmentsGraphqlChildLimits",
  "V2CompartmentsGraphqlGetCompartmentByV1AccountGraphQLResponse",
  "V2CompartmentsGraphqlGetCompartmentLimitsGraphQLResponse",
  "V2CompartmentsGraphqlGetV1AccountByCompartmentGraphQLResponse",
  "V2CompartmentsRevokeInviteResponse",
  "V2CompartmentsSendInviteResponse",
  "V2CompartmentsUpdateWorkspaceParentResponse",
  "V2ConfigurationVersionConfigurationChange",
  "V2ConfigurationVersionConfiguredObjectReference",
  "V2ConfigurationVersionConfiguredObjectVersions",
  "V2ConfigurationVersionListConfigurationVersionsResponse",
  "V2ConnectionSessionConnection",
  "V2ContractingContractInformation",
  "V2ContractingContractTable",
  "V2ContractingContractTableRow",
  "V2ContractingCreateContractInformationResponse",
  "V2ContractingCreateContractInformationV2Response",
  "V2ControlPlaneGetFunctionImplementationVersionForImplementationResponse",
  "V2ControlPlaneListFunctionImplementationVersionsResponse",
  "V2ControlPlaneListFunctionImplementationsResponse",
  "V2ControlPlaneListUserFunctionImplementationsByScriptTypeResponse",
  "V2ControlPlaneSourceEntry",
  "V2CrudAccountId",
  "V2CrudInspectTenantMigrationRecordsResponse",
  "V2CrudListInlineTenantMigrationRecordsResponse",
  "V2CrudListRecordsByAccountIdResponse",
  "V2CrudListRecordsByTenantIdResponse",
  "V2CrudListTenantMigrationRecordsResponse",
  "V2CrudMutateTenantMigrationRecordsWithUpdateOpsResponse",
  "V2CrudTenantId",
  "V2CrudVerifyAtomicBatchWriteBulkUpdateResponse",
  "V2CrudVerifyAtomicBatchWriteResponse",
  "V2CrudVerifyOptimisticLockingResponse",
  "V2CrudVerifyReadPathsResponse",
  "V2CrudVerifySnapshotReadsResponse",
  "V2CryptoInvestmentsAcceptCryptoInvestmentTermsResponse",
  "V2CryptoInvestmentsAmount",
  "V2CryptoInvestmentsCreateCryptoInvestmentDepositResponse",
  "V2CryptoInvestmentsCreateCryptoInvestmentWithdrawalResponse",
  "V2CryptoInvestmentsGetCryptoInvestmentInfoResponse",
  "V2CryptoInvestmentsInvestmentInfo",
  "V2CryptoInvestmentsListCryptoInvestmentDepositsResponse",
  "V2CryptoInvestmentsListCryptoInvestmentInfoResponse",
  "V2CryptoInvestmentsListCryptoInvestmentWithdrawalsResponse",
  "V2CryptoInvestmentsStatusTransitions",
  "V2CurrencyConversionsPublicCurrencyConversionAmountBlock",
  "V2CurrencyConversionsPublicListCurrencyConversionsResponse",
  "V2CustomRolesCustomRoleWithUsage",
  "V2CustomRolesJobResourceOverride",
  "V2CustomRolesListCustomRolesResponse",
  "V2CustomerConsentListCustomerConsentRequestsResponse",
  "V2DashPlatCreateOrUpdateAllCorgisResponse",
  "V2DashPlatListCorgiResponse",
  "V2DashPlatRetrieveAllCorgisResponse",
  "V2DashPlatRetrieveUserPermissionsResponse",
  "V2DashPlatTestEmptyResponseResponse",
  "V2DataDataEntry",
  "V2DataExternalUrl",
  "V2DataListReportsResponse",
  "V2DataListSchemasResponse",
  "V2DataParametersEntry",
  "V2DataQuery",
  "V2DataReportRunParameterValue",
  "V2DataReportRunParameterValueArray",
  "V2DataResult",
  "V2DataResultColumn",
  "V2DataResultFile",
  "V2DataResultInline",
  "V2DataResultOptions",
  "V2DataResultRow",
  "V2DataResultValue",
  "V2DataRunStatusDetails",
  "V2DataSchemaColumn",
  "V2DataSchemaColumnReference",
  "V2DebitDisputesDebitDisputeBankTransferObject",
  "V2DebitDisputesDebitDisputeStatusDetails",
  "V2DebitDisputesDebitDisputeStatusDetailsFailedReason",
  "V2DebitDisputesDebitDisputeStatusTransitions",
  "V2DebitDisputesListDebitDisputesResponse",
  "V2DefaultAccountMappingListDefaultAccountMappingVersionsResponse",
  "V2DeliveryDateOrTime",
  "V2DeliveryQualifiersEntry",
  "V2DeliveryQuantity",
  "V2DeliveryReferenceId",
  "V2DiscoveryBusinessConcept",
  "V2DiscoveryDiscoveryContext",
  "V2DiscoveryMetricDimension",
  "V2DiscoveryMetricResultDetails",
  "V2DiscoveryOutputColumnSchema",
  "V2DiscoveryParametersEntry",
  "V2DiscoveryReportParameter",
  "V2DiscoveryReportParameterArrayDetails",
  "V2DiscoveryReportParameterEnumDetails",
  "V2DiscoveryReportResultDetails",
  "V2DiscoverySchemaColumn",
  "V2DiscoverySchemaColumnReference",
  "V2DiscoverySchemaResultDetails",
  "V2DiscoverySearchDiscoveryResponse",
  "V2DispatchAndDeliveriesAmazonEventbridgeDeliveryDetails",
  "V2DispatchAndDeliveriesAzureEventGridDeliveryDetails",
  "V2DispatchAndDeliveriesEventDestinationEventDelivery",
  "V2DispatchAndDeliveriesHeader",
  "V2DispatchAndDeliveriesListDeliveriesForEventResponse",
  "V2DispatchAndDeliveriesListEventDeliveriesForDestinationResponse",
  "V2DispatchAndDeliveriesListEventsForEventDestinationResponse",
  "V2DispatchAndDeliveriesRetrieveEventWithDeliveriesResponse",
  "V2DispatchAndDeliveriesTruncatedDispatch",
  "V2DispatchAndDeliveriesWebhookDeliveryDetails",
  "V2DocsRetrieveDocResponse",
  "V2DocsSearchDocsResponse",
  "V2DocsSearchHit",
  "V2EarnedCreditsEarnedCreditPeriod",
  "V2EarnedCreditsEarnedCreditRevenueShare",
  "V2EarnedCreditsEarnedCreditReward",
  "V2EarnedCreditsEarnedCreditSimulation",
  "V2EarnedCreditsEarnedCreditStatusTransitions",
  "V2EarnedCreditsListEarnedCreditsResponse",
  "V2EntityMappingEntityMapping",
  "V2EntityMappingGetEntityMappingResponse",
  "V2EntityMappingLegalEntity",
  "V2EntityMappingMerchant",
  "V2EpGrpcSrvDirectoryProfileMachinePaymentProtocol",
  "V2EpGrpcSrvDirectoryProfileMachinePaymentProtocolEndpoint",
  "V2EpGrpcSrvDirectoryProfileModelContextProtocol",
  "V2EpGrpcSrvDirectoryProfileStripeApps",
  "V2EpGrpcSrvDirectoryProfileStripeProjects",
  "V2EpGrpcSrvSearchDirectoryProfilesResponse",
  "V2EventDestinationsAmazonEventBridgeConfiguration",
  "V2EventDestinationsAzureEventGridConfiguration",
  "V2EventDestinationsAzureEventGridRegion",
  "V2EventDestinationsClient",
  "V2EventDestinationsDashboardUser",
  "V2EventDestinationsDecryptedWebhookSigningKey",
  "V2EventDestinationsEventDestinationDisabledDetails",
  "V2EventDestinationsEventDestinationStatusDetails",
  "V2EventDestinationsEventReason",
  "V2EventDestinationsEventType",
  "V2EventDestinationsListAmazonEventBridgeRegionsResponse",
  "V2EventDestinationsListAzureEventGridRegionsResponse",
  "V2EventDestinationsListEventDestinationsResponse",
  "V2EventDestinationsListEventTypesResponse",
  "V2EventDestinationsRegion",
  "V2EventDestinationsRetrieveEventDestinationWebhookSigningKeyResponse",
  "V2EventDestinationsReverseApiConfiguration",
  "V2EventDestinationsWebhookEndpointConfiguration",
  "V2EventsClient",
  "V2EventsDashboardUser",
  "V2EventsEventReason",
  "V2EventsListEventsForDashboardResponse",
  "V2EventsListEventsResponse",
  "V2EventsListLogicalEventsForDashboardResponse",
  "V2EventsLogicalEvent",
  "V2ExpenseManagementCardAcceptorDetails",
  "V2ExpenseManagementCounterparty",
  "V2ExpenseManagementExpenseAssociation",
  "V2ExpenseManagementExpenseFlowAssociation",
  "V2ExpenseManagementListExpensesResponse",
  "V2ExpenseManagementRetrieveExpenseAssociationsByFlowsResponse",
  "V2ExpenseManagementRetrieveExpenseAssociationsResponse",
  "V2ExperienceAccountNumber",
  "V2ExperienceAccountTrait",
  "V2ExperienceAccountTraitController",
  "V2ExperienceActiveStatusDetails",
  "V2ExperienceActivitySummary",
  "V2ExperienceAgenticCommerceSummary",
  "V2ExperienceAggregateData",
  "V2ExperienceAggregateDataUSDe",
  "V2ExperienceAmountDue",
  "V2ExperienceAssociatedConnectedAccountData",
  "V2ExperienceAssociatedConnectedAccountDataV2",
  "V2ExperienceAttachment",
  "V2ExperienceAttributeEntry",
  "V2ExperienceAuthErrorV2",
  "V2ExperienceAutomaticTax",
  "V2ExperienceBalanceByCurrencyEntry",
  "V2ExperienceBalanceVolumeSummary",
  "V2ExperienceBillingAnalyticsControls",
  "V2ExperienceBillingAnalyticsUsageMeterPreferences",
  "V2ExperienceBillingMode",
  "V2ExperienceBooleanPreference",
  "V2ExperienceBooleanPreferences",
  "V2ExperienceCOABannerImportSetId",
  "V2ExperienceCall",
  "V2ExperienceCallRequest",
  "V2ExperienceCancellationDetails",
  "V2ExperienceCapabilitiesSummary",
  "V2ExperienceCardPresentPropertiesV2",
  "V2ExperienceChartLayout",
  "V2ExperienceChatTranscript",
  "V2ExperienceColumnWidth",
  "V2ExperienceCreatePointInTimeResponse",
  "V2ExperienceCriticalMessage",
  "V2ExperienceCurrencySummary",
  "V2ExperienceCustomListPage",
  "V2ExperienceCustomLists",
  "V2ExperienceCustomObjectTablePreference",
  "V2ExperienceCustomObjectTablePreferences",
  "V2ExperienceCustomerEnrichedInvoiceSettings",
  "V2ExperienceDarkModeBeta",
  "V2ExperienceDashboardNavPinnedShortcut",
  "V2ExperienceDashboardNavRecentShortcut",
  "V2ExperienceDashboardNavShortcuts",
  "V2ExperienceDefaultSettings",
  "V2ExperienceDeletePointInTimeResponse",
  "V2ExperienceDismissedDashboardCallouts",
  "V2ExperienceDisputeForInvoice",
  "V2ExperienceEvidenceDetails",
  "V2ExperienceExampleSavedColumns",
  "V2ExperienceFraudRiskSummary",
  "V2ExperienceGetUserStateResponse",
  "V2ExperienceHardwareOrderItem",
  "V2ExperienceHardwareSkuImage",
  "V2ExperienceInactiveStatusDetails",
  "V2ExperienceInterval",
  "V2ExperienceLatestChargeForInvoice",
  "V2ExperienceLifetimeByCurrencyEntry",
  "V2ExperienceLines",
  "V2ExperienceLinkedConversation",
  "V2ExperienceListPagesEntry",
  "V2ExperienceListViews",
  "V2ExperienceManagedPayments",
  "V2ExperienceMarketingOverviewPreferences",
  "V2ExperienceMonthlyInstallments",
  "V2ExperienceNextActionForInvoice",
  "V2ExperienceNoOpChargeReadResponse",
  "V2ExperienceNoOpConnectedAccountReadResponse",
  "V2ExperienceNoOpCustomerReadResponse",
  "V2ExperienceNoOpDashboardFullChromeAndTestModeReadResponse",
  "V2ExperienceNoOpDisputeReadResponse",
  "V2ExperienceNoOpFinancialStatementReadResponse",
  "V2ExperienceNoOpInvoiceReadResponse",
  "V2ExperienceNoOpRadarDashboardDisputesReadResponse",
  "V2ExperienceNoOpReportingReadResponse",
  "V2ExperienceNoOpSubscriptionReadResponse",
  "V2ExperienceOrchestratedCommerceAgreements",
  "V2ExperiencePagesEntry",
  "V2ExperiencePauseCollection",
  "V2ExperiencePausedStatusDetails",
  "V2ExperiencePhase",
  "V2ExperiencePinnedSandbox",
  "V2ExperiencePlatformControlledPermissionConfig",
  "V2ExperiencePostUserStateResponse",
  "V2ExperiencePrebillingData",
  "V2ExperiencePriceDetails",
  "V2ExperiencePublicComment",
  "V2ExperienceRadarCustomViewPage",
  "V2ExperienceRadarCustomViews",
  "V2ExperienceRecentSandbox",
  "V2ExperienceRecurringFields",
  "V2ExperienceRejectionSummary",
  "V2ExperienceReportDownloadPreference",
  "V2ExperienceReportDownloadPreferences",
  "V2ExperienceRevenueRecognitionColumnOrderPreferences",
  "V2ExperienceRevenueRecognitionOverview",
  "V2ExperienceRevenueRecognitionSavedColumnOrder",
  "V2ExperienceScheduledPayment",
  "V2ExperienceSearchAIWindow",
  "V2ExperienceSearchDocument",
  "V2ExperienceSearchListResponse",
  "V2ExperienceShippingAddress",
  "V2ExperienceShippingDetails",
  "V2ExperienceStatusDetails",
  "V2ExperienceStringPreference",
  "V2ExperienceStringPreferences",
  "V2ExperienceSubscriptionItems",
  "V2ExperienceSubscriptionStatusDetails",
  "V2ExperienceTaxSummary",
  "V2ExperienceTier",
  "V2ExperienceTimeDimension",
  "V2ExperienceTranscriptItem",
  "V2ExperienceTransformQuantityForSubscription",
  "V2ExperienceTwilioMessage",
  "V2ExperienceTwilioMessageAttachment",
  "V2ExperienceUserStatePreference",
  "V2ExperienceUserTask",
  "V2ExperienceUserTaskSummary",
  "V2ExperienceV2Summary",
  "V2ExperienceVerificationAttempt",
  "V2ExperienceVerificationAttemptSummary",
  "V2ExperienceViewList",
  "V2ExperienceViewsEntry",
  "V2ExperienceWorkbenchSettingsState",
  "V2FabricFabricResponse",
  "V2FeatureFlagsEvaluationsEntry",
  "V2FeatureFlagsExperimentOverridesEntry",
  "V2FeatureFlagsFlagOverridesEntry",
  "V2FeatureFlagsVariantsEntry",
  "V2FeaturesPublicCurrencies",
  "V2FeaturesPublicFeaturesApi",
  "V2FeaturesPublicPaymentsOutboundTransfersFeatureContainer",
  "V2FeaturesPublicStatusDetails",
  "V2FeaturesPublicStorageFinancialAddressesFeatureContainer",
  "V2FeaturesPublicStorageInboundTransfersFeatureContainer",
  "V2FeaturesPublicStorageOutboundPaymentsFeatureContainer",
  "V2FeaturesPublicStorageOutboundTransfersFeatureContainer",
  "V2FeeAmount",
  "V2FeeFeeBatchAdjustments",
  "V2FeeFeeBatchCollectedBy",
  "V2FeeFeeBatchCollectionRecord",
  "V2FeeFeeBatchCollectionRecordTax",
  "V2FeeFeeBatchStatusTransitions",
  "V2FeeFeeBatchTax",
  "V2FeeFeeEntryChargedBy",
  "V2FeeFeeEntryChargedByDetails",
  "V2FeeFeeEntryTax",
  "V2FeeListFeeBatchesResponse",
  "V2FeeListFeeEntriesResponse",
  "V2FeeReportingEstimateFeeTaxAmount",
  "V2FeeReportingEstimateFeesResponse",
  "V2FeeReportingFee",
  "V2FeeReportingGetFeeEntriesResponse",
  "V2FeeReportingProductFeatureFee",
  "V2FeeReportingTax",
  "V2FinancialAccountOnboardingRetrievePlatformEfsEligibilityResponse",
  "V2FinancialAccountStatementsEndingBalanceEntry",
  "V2FinancialAccountStatementsListFinancialAccountStatementsResponse",
  "V2FinancialAccountStatementsStartingBalanceEntry",
  "V2FinancialAccountStatementsStatementFileData",
  "V2FinancialAccountStatementsStatementFileDownloadUrl",
  "V2FinancialAccountStatementsStatementFilesByCurrency",
  "V2FinancialAccountStatementsStatementPeriod",
  "V2FinancialAccountStatementsValuesEntry",
  "V2FinancialAccountsOnboardingAvailableEntry",
  "V2FinancialAccountsOnboardingBalanceByFundsType",
  "V2FinancialAccountsOnboardingCurrencies",
  "V2FinancialAccountsOnboardingCurrencyNetworksEntry",
  "V2FinancialAccountsOnboardingFeaturesApi",
  "V2FinancialAccountsOnboardingFinancialAccountAccruedFeesHash",
  "V2FinancialAccountsOnboardingFinancialAccountBalanceHash",
  "V2FinancialAccountsOnboardingFinancialAccountCreditFundedByHash",
  "V2FinancialAccountsOnboardingFinancialAccountCreditFundedByPlatformHash",
  "V2FinancialAccountsOnboardingFinancialAccountCreditHash",
  "V2FinancialAccountsOnboardingFinancialAccountDepositInsuranceEligibility",
  "V2FinancialAccountsOnboardingFinancialAccountFlowSettings",
  "V2FinancialAccountsOnboardingFinancialAccountFlowSettingsReceivedDebits",
  "V2FinancialAccountsOnboardingFinancialAccountFlowSettingsReceivedDebitsAch",
  "V2FinancialAccountsOnboardingFinancialAccountMultiprocessorSettlementHash",
  "V2FinancialAccountsOnboardingFinancialAccountOtherHash",
  "V2FinancialAccountsOnboardingFinancialAccountPaymentsHash",
  "V2FinancialAccountsOnboardingFinancialAccountRestrictions",
  "V2FinancialAccountsOnboardingFinancialAccountSavingsHash",
  "V2FinancialAccountsOnboardingFinancialAccountSavingsInterestHash",
  "V2FinancialAccountsOnboardingFinancialAccountSavingsInterestRateHash",
  "V2FinancialAccountsOnboardingFinancialAccountStorageCryptoHash",
  "V2FinancialAccountsOnboardingFinancialAccountStorageHash",
  "V2FinancialAccountsOnboardingInboundPendingEntry",
  "V2FinancialAccountsOnboardingOutboundPendingEntry",
  "V2FinancialAccountsOnboardingPaymentsOutboundTransfersFeatureContainer",
  "V2FinancialAccountsOnboardingStartingBalance",
  "V2FinancialAccountsOnboardingStatusDetails",
  "V2FinancialAccountsOnboardingStorageFinancialAddressesFeatureContainer",
  "V2FinancialAccountsOnboardingStorageInboundTransfersFeatureContainer",
  "V2FinancialAccountsOnboardingStorageOutboundPaymentsFeatureContainer",
  "V2FinancialAccountsOnboardingStorageOutboundTransfersFeatureContainer",
  "V2FinancialAccountsPublicAvailableEntry",
  "V2FinancialAccountsPublicBalanceByFundsType",
  "V2FinancialAccountsPublicCashEntry",
  "V2FinancialAccountsPublicClosed",
  "V2FinancialAccountsPublicCryptoWallet",
  "V2FinancialAccountsPublicCryptoWalletParameters",
  "V2FinancialAccountsPublicCurrencyNetworksEntry",
  "V2FinancialAccountsPublicFinancialAccountAccruedFeesHash",
  "V2FinancialAccountsPublicFinancialAccountBalance",
  "V2FinancialAccountsPublicFinancialAccountBalanceHash",
  "V2FinancialAccountsPublicFinancialAccountCreditFundedByHash",
  "V2FinancialAccountsPublicFinancialAccountCreditFundedByPlatformHash",
  "V2FinancialAccountsPublicFinancialAccountCreditHash",
  "V2FinancialAccountsPublicFinancialAccountDepositInsuranceEligibility",
  "V2FinancialAccountsPublicFinancialAccountExportedWallet",
  "V2FinancialAccountsPublicFinancialAccountFlowSettings",
  "V2FinancialAccountsPublicFinancialAccountFlowSettingsReceivedDebits",
  "V2FinancialAccountsPublicFinancialAccountFlowSettingsReceivedDebitsAch",
  "V2FinancialAccountsPublicFinancialAccountMultiprocessorSettlementHash",
  "V2FinancialAccountsPublicFinancialAccountOtherHash",
  "V2FinancialAccountsPublicFinancialAccountPaymentsHash",
  "V2FinancialAccountsPublicFinancialAccountRestrictions",
  "V2FinancialAccountsPublicFinancialAccountSavingsHash",
  "V2FinancialAccountsPublicFinancialAccountSavingsInterestHash",
  "V2FinancialAccountsPublicFinancialAccountSavingsInterestRateHash",
  "V2FinancialAccountsPublicFinancialAccountStorageCryptoHash",
  "V2FinancialAccountsPublicFinancialAccountStorageHash",
  "V2FinancialAccountsPublicFinancialAccountWalletExport",
  "V2FinancialAccountsPublicFinancialAccountWalletExportCredentials",
  "V2FinancialAccountsPublicFinancialAccountWalletExportCredentialsWallet",
  "V2FinancialAccountsPublicFinancialAccountWalletExportEncryptedCredentials",
  "V2FinancialAccountsPublicForwardingSettings",
  "V2FinancialAccountsPublicInboundPendingEntry",
  "V2FinancialAccountsPublicListFinancialAccountBalancesResponse",
  "V2FinancialAccountsPublicListFinancialAccountsResponse",
  "V2FinancialAccountsPublicOutboundPendingEntry",
  "V2FinancialAccountsPublicSelfCustodiedCryptoWallet",
  "V2FinancialAccountsPublicStartingBalance",
  "V2FinancialAccountsPublicStatusDetails",
  "V2FinancialAddressesAUBankAccountCredentials",
  "V2FinancialAddressesAbaBankAccountDetails",
  "V2FinancialAddressesAddress",
  "V2FinancialAddressesBankAccountV2",
  "V2FinancialAddressesBankCodeBankAccountDetails",
  "V2FinancialAddressesBreBBankAccountDetails",
  "V2FinancialAddressesBsbBankAccountDetails",
  "V2FinancialAddressesCABankAccountCredentials",
  "V2FinancialAddressesClabeBankAccountDetails",
  "V2FinancialAddressesCpaBankAccountDetails",
  "V2FinancialAddressesCredentials",
  "V2FinancialAddressesCryptoWalletCredentials",
  "V2FinancialAddressesCryptoWalletSupportedNetworkDetails",
  "V2FinancialAddressesCryptoWalletV2",
  "V2FinancialAddressesFinancialAddressCreditSimulation",
  "V2FinancialAddressesFinancialAddressDebitSimulation",
  "V2FinancialAddressesFinancialAddressGeneratedMicrodeposits",
  "V2FinancialAddressesGBBankAccountCredentials",
  "V2FinancialAddressesIbanBankAccountDetails",
  "V2FinancialAddressesListFinancialAddressesResponse",
  "V2FinancialAddressesListFinancialAddressesV2Response",
  "V2FinancialAddressesMXBankAccountCredentials",
  "V2FinancialAddressesNipBankAccountDetails",
  "V2FinancialAddressesPixBankAccountDetails",
  "V2FinancialAddressesSepaBankAccountCredentials",
  "V2FinancialAddressesSimulateFinancialAddressCreditResponse",
  "V2FinancialAddressesSortCodeBankAccountDetails",
  "V2FinancialAddressesSupportedNetworkDetailsEntry",
  "V2FinancialAddressesUSBankAccountCredentials",
  "V2FirehoseDestinationAmazonS3Config",
  "V2FirehoseDestinationListLogDestinationsResponse",
  "V2FirehoseDestinationWebhookConfig",
  "V2FlowSearchCardSpendTimeseriesBucket",
  "V2FlowSearchGetCardSpendInsightsResponse",
  "V2FlowSearchRetrieveFlowsFilterCount",
  "V2FlowSearchSearchFlowsResponse",
  "V2FlowSearchSpendPerCurrencyEntry",
  "V2FlowSearchSucceededSpendPerCurrencyEntry",
  "V2FundingSessionsCryptoWalletFundingOptions",
  "V2FundingSessionsFinancialAddressOptions",
  "V2FundingSessionsInternalCryptoWallet",
  "V2FundingSessionsInternalCryptoWalletFundingOptions",
  "V2FundingSessionsInternalCryptoWalletSupportedNetworkDetails",
  "V2FundingSessionsInternalFinancialAddressOptions",
  "V2FundingSessionsInternalFundingOptions",
  "V2FundingSessionsInternalFundingSessionCryptoWallet",
  "V2FundingSessionsInternalFundingSessionReceivedCreditCryptoWalletTransferInternalView",
  "V2FundingSessionsInternalFundingSessionReceivedCreditInternalView",
  "V2FundingSessionsInternalListFundingSessionReceivedCreditsResponse",
  "V2FundingSessionsInternalMerchantBranding",
  "V2FundingSessionsInternalSupportedNetworkDetailsEntry",
  "V2FxQuoteForOutboundPaymentQuotesRate",
  "V2FxQuoteForOutboundPaymentQuotesRatesEntry",
  "V2FxQuotesFxQuoteValidationFailure",
  "V2FxQuotesRatesEntry",
  "V2FxQuotesValidateFxQuoteResponse",
  "V2GearsetWebhookRecordGearsetDeploymentResponse",
  "V2GraphqlAccountsAccountLinkInternal",
  "V2GraphqlAccountsChallengeSecretRequired",
  "V2GraphqlAccountsCompleteAccountLinkResponse",
  "V2GraphqlAccountsConfigurationSupportableCapabilitiesResource",
  "V2GraphqlAccountsConsumeAccountLinkResponse",
  "V2GraphqlAccountsCreatePayoutLinkUrlInternalResponse",
  "V2GraphqlAccountsExpiredResponse",
  "V2GraphqlAccountsGeneratedNewEmailResponse",
  "V2GraphqlAccountsRetrieveAccountLinkUrlsInternalResponse",
  "V2GraphqlAccountsRetrieveRecipientConfigurationSupportableCapabilitiesResponse",
  "V2GraphqlAccountsVTwoAccountLinkInternal",
  "V2GraphqlAccountsVTwoCommunicationSettings",
  "V2GraphqlAccountsVTwoCompleteAccountLinkResponse",
  "V2GraphqlAccountsVTwoConsumeAccountLinkResponse",
  "V2GraphqlAccountsVTwoExpiredResponse",
  "V2GraphqlAccountsVTwoFeatureConfigs",
  "V2GraphqlAccountsVTwoGeneratedNewEmailResponse",
  "V2GraphqlAccountsVTwoListAccountInternalResourcesResponse",
  "V2GraphqlAccountsVTwoRecipientActionFilterCount",
  "V2GraphqlAccountsVTwoRecipientCountryFilterCount",
  "V2GraphqlAccountsVTwoRecipientFeatureConfigs",
  "V2GraphqlAccountsVTwoRetrieveAccountCommunicationSettingsResponse",
  "V2GraphqlAccountsVTwoRetrieveAccountFeatureConfigsResponse",
  "V2GraphqlAccountsVTwoRetrieveAccountLinkUrlsInternalResponse",
  "V2GraphqlAccountsVTwoSearchAccountInternalResourcesResponse",
  "V2GraphqlAccountsVTwoSearchRecipientsInternalActionFilterCountsResponse",
  "V2GraphqlAccountsVTwoSearchRecipientsInternalCountryFilterCountsResponse",
  "V2GraphqlAccountsVTwoSearchRecipientsInternalResponse",
  "V2GraphqlAccountsVTwoUpdateAccountCommunicationSettingsResponse",
  "V2GraphqlAccountsVTwoUpdateAccountFeatureConfigsResponse",
  "V2GraphqlAccountsVTwoValidUatResponse",
  "V2GraphqlAccountsValidUatResponse",
  "V2HealthAlertsAPIError",
  "V2HealthAlertsAPIErrorConnectedAccountImpact",
  "V2HealthAlertsAPILatency",
  "V2HealthAlertsAPILatencyConnectedAccountImpact",
  "V2HealthAlertsAuthorizationRateDrop",
  "V2HealthAlertsAuthorizationRateDropDimension",
  "V2HealthAlertsDocumentationLink",
  "V2HealthAlertsElementsError",
  "V2HealthAlertsEventGenerationFailure",
  "V2HealthAlertsFraudRate",
  "V2HealthAlertsInvoiceCountDropped",
  "V2HealthAlertsIssuingAuthorizationRequestErrors",
  "V2HealthAlertsIssuingAuthorizationRequestTimeout",
  "V2HealthAlertsListAlertHistoryResponse",
  "V2HealthAlertsListAlertsResponse",
  "V2HealthAlertsMeterEventSummariesDelayed",
  "V2HealthAlertsMetronomeNotificationLatency",
  "V2HealthAlertsPaymentMethodError",
  "V2HealthAlertsPaymentMethodErrorConnectedAccountImpact",
  "V2HealthAlertsSepaDebitDelayed",
  "V2HealthAlertsTrafficVolumeDrop",
  "V2HealthAlertsWebhookLatency",
  "V2HostedRecipientsOnboardingFlagsEntry",
  "V2IamIamAuthTokenDeleteIamAuthTokenResponse",
  "V2IamSsoDomainsListAggregateSsoDomainsResponse",
  "V2IamSsoDomainsListSamlConfiguredSsoDomainsResponse",
  "V2IamSsoDomainsListSsoDomainsResponse",
  "V2IamSsoDomainsMergeConflict",
  "V2IamSsoDomainsRetrieveSamlAuthAssertionResponse",
  "V2IamSsoDomainsRetrieveSsoDomainDnsVerificationCodeResponse",
  "V2IamSsoDomainsSamlConfiguration",
  "V2IamSsoDomainsValidateMergeSsoDomainsResponse",
  "V2IamSsoRoleAssignmentConfigSsoRoleAssignmentConfig",
  "V2InboundTransferMandateCanceled",
  "V2InboundTransferMandateInboundTransferMandateBacs",
  "V2InboundTransferMandateInboundTransferMandateStatusDetails",
  "V2InboundTransferMandateInboundTransferMandateStatusTransitions",
  "V2InboundTransferMandateInboundTransferMandateUserAcceptedDetails",
  "V2InboundTransferMandateListInboundTransferMandatesResponse",
  "V2InboundTransferMandateOnlineAcceptance",
  "V2InboundTransfersGetInboundTransferLimitsResponse",
  "V2InboundTransfersInboundTransferBankDebitFailedEntry",
  "V2InboundTransfersInboundTransferBankDebitReturnedEntry",
  "V2InboundTransfersInboundTransferFrom",
  "V2InboundTransfersInboundTransferTo",
  "V2InboundTransfersListInboundTransfersResponse",
  "V2InboundTransfersPaymentMethod",
  "V2InquiryAppealData",
  "V2InquiryAuthorizationDocumentsData",
  "V2InquiryListInquiriesResponse",
  "V2InquiryMultiProcessorData",
  "V2InquiryMultiProcessorFileData",
  "V2InquiryPaymentProcessingData",
  "V2InquiryProductRemovalData",
  "V2InquirySelfFundingContextData",
  "V2InquirySourceOfFundsData",
  "V2InquirySourceOfWealthData",
  "V2InquirySubject",
  "V2InquiryTransactionContextData",
  "V2IntegrationDataError",
  "V2IntegrationDataLlamaLogDetails",
  "V2IntegrationDataMcpAnnotations",
  "V2IntegrationDataMcpClientInfo",
  "V2IntegrationDataMcpLogDetails",
  "V2IntegrationDataMcpToolsCallDetails",
  "V2IntegrationDataRemoteFunctionDetails",
  "V2IntegrationDataRetrieveIntegrationDataPointResponse",
  "V2IntegrationDataScriptRun",
  "V2IntegrationDataScriptRunDetails",
  "V2IntegrationDataSearchIntegrationDataPointsResponse",
  "V2IntegrationHealthAlertDetail",
  "V2IntegrationHealthAlertHealthInsight",
  "V2IntegrationHealthDeactivateAlertForMhnsResolutionResponse",
  "V2IntegrationHealthEnabledByFlag",
  "V2IntegrationHealthEnabledConfig",
  "V2IntegrationHealthExperiment",
  "V2IntegrationHealthExperimentConfig",
  "V2IntegrationHealthFlagConfig",
  "V2IntegrationHealthIntegrationHealthInsight",
  "V2IntegrationHealthListAlertsByPredicateResponse",
  "V2IntegrationHealthListIntegHlthAlertsResponse",
  "V2IntegrationHealthPatternProgressChapter",
  "V2IntegrationHealthPatternProgressStep",
  "V2IntegrationHealthPredicateAlertEntry",
  "V2IntegrationHealthPredicateData",
  "V2IntegrationHealthRecommendedAction",
  "V2IntegrationHealthRetrieveInsightsByAlertIdsResponse",
  "V2IntegrationHealthRetrieveInsightsByRequestIdResponse",
  "V2IntegrationHealthRetrievePredicateByInsightTypeResponse",
  "V2IntegrationHealthRetrievePredicateByNameResponse",
  "V2InvoicingAuditDetails",
  "V2InvoicingEligibilityGetInvoicingEligibilitiesAtTimeV2Response",
  "V2InvoicingEligibilityInvoicingEligibilityAtTime",
  "V2InvoicingEligibilityInvoicingEligibilityAuditDetails",
  "V2InvoicingEligibilityProductFeatureEligibilitiesEntry",
  "V2InvoicingGetInvoicingEligibilitiesAtTimeResponse",
  "V2InvoicingInvoicingEligibilityAtTime",
  "V2InvoicingProductFeatureEligibilitiesEntry",
  "V2JournalEntryJournalEntrySource",
  "V2JournalEntryListJournalEntriesResponse",
  "V2KYCProjectionInternalGraphqlRetrieveKYCProjectionByCompartmentGQLResponse",
  "V2KeyManagementEncryptedSecret",
  "V2KeyManagementListApiKeysResponse",
  "V2KeyManagementManagedBy",
  "V2KeyManagementPublishableKeyToken",
  "V2KeyManagementSecretKeyToken",
  "V2LedgerAccountLedgerAccountVersionVersionMetadata",
  "V2LedgerAccountListAccountVersionsResponse",
  "V2LedgerAccountListLedgerAccountsResponse",
  "V2LlamaAddLlamaKidsResponse",
  "V2LlamaAttributesEntry",
  "V2LlamaCheckoutAddress",
  "V2LlamaCheckoutBuyer",
  "V2LlamaDeprecatedMetadataEntry",
  "V2LlamaHabitatsEntry",
  "V2LlamaIngestLlamaEventResponse",
  "V2LlamaListLlamasNotForProdUseResponse",
  "V2LlamaListLlamasResponse",
  "V2LlamaLlamaAliases",
  "V2LlamaLlamaCoatColorHex",
  "V2LlamaLlamaCoatColorNamed",
  "V2LlamaLlamaCoatColorRolloutConfigGatedVariant",
  "V2LlamaLlamaCoatPatternNewerVersionVariant",
  "V2LlamaLlamaCoatPatternRolloutConfigGatedVariant",
  "V2LlamaLlamaCoatPatternSolid",
  "V2LlamaLlamaCoatPatternSpotted",
  "V2LlamaLlamaCoatPatternUnknownVariant",
  "V2LlamaLlamaDetails",
  "V2LlamaLlamaHabitat",
  "V2LlamaLlamaHabitatSpec",
  "V2LlamaLlamaHabitats",
  "V2LlamaLlamaOrigin",
  "V2LlamaLlamaPrimitiveTools",
  "V2LlamaPayloadEntry",
  "V2LlamaPrimitiveLlamaAttribute",
  "V2LlamaResponseGatingMessage",
  "V2LlamaRetrieveAllLlamasByTypeResponse",
  "V2LlamaRetrieveJavaLlamaCompartmentResponse",
  "V2LlamaValuesEntry",
  "V2Metadata",
  "V2MhnsAlertGroupsAccount",
  "V2MhnsAlertGroupsAccountImpactData",
  "V2MhnsAlertGroupsAlertRecommendation",
  "V2MhnsAlertGroupsAlertRecommendationComponent",
  "V2MhnsAlertGroupsAlertRecommendationLink",
  "V2MhnsAlertGroupsConnectedAccountImpactData",
  "V2MhnsAlertGroupsHealthAlertGroupCounts",
  "V2MhnsAlertGroupsHealthAlertGroupEmailNotification",
  "V2MhnsAlertGroupsHealthAlertGroupImpact",
  "V2MhnsAlertGroupsHealthEventUserMetadata",
  "V2MhnsAlertGroupsHelpResource",
  "V2MhnsAlertGroupsListHealthAlertGroupEmailNotificationsResponse",
  "V2MhnsAlertGroupsListHealthAlertGroupsResponse",
  "V2MhnsAlertsAccount",
  "V2MhnsAlertsAccountImpactData",
  "V2MhnsAlertsAlertRecommendation",
  "V2MhnsAlertsAlertRecommendationComponent",
  "V2MhnsAlertsAlertRecommendationLink",
  "V2MhnsAlertsConnectedAccountImpactData",
  "V2MhnsAlertsHealthAlertCounts",
  "V2MhnsAlertsHealthAlertEmailNotification",
  "V2MhnsAlertsHealthAlertHistoryEntry",
  "V2MhnsAlertsHealthAlertNotification",
  "V2MhnsAlertsHealthEventUserMetadata",
  "V2MhnsAlertsHelpResource",
  "V2MhnsAlertsListHealthAlertCategoriesResponse",
  "V2MhnsAlertsListHealthAlertEmailNotificationsResponse",
  "V2MhnsAlertsListHealthAlertHistoryEntriesResponse",
  "V2MhnsAlertsListHealthAlertNotificationsResponse",
  "V2MhnsAlertsListHealthAlertWebhookDestinationsResponse",
  "V2MhnsAlertsListHealthAlertsResponse",
  "V2MhnsAlertsThresholdOption",
  "V2MhnsAlertsWebhookNotificationSummary",
  "V2MhnsInsightsAccount",
  "V2MhnsInsightsAdvancedAttacksGenericCardTestingPayload",
  "V2MhnsInsightsBatchApiOpportunityPayload",
  "V2MhnsInsightsHealthEventUserMetadata",
  "V2MhnsInsightsHealthInsightCounts",
  "V2MhnsInsightsHealthInsightLog",
  "V2MhnsInsightsHealthInsightNotification",
  "V2MhnsInsightsIntegHlthMetadata",
  "V2MhnsInsightsListHealthInsightLogsResponse",
  "V2MhnsInsightsListHealthInsightNotificationsResponse",
  "V2MhnsInsightsListHealthInsightsResponse",
  "V2MhnsInsightsListOrganizationHealthInsightsResponse",
  "V2MhnsInsightsManualResolution",
  "V2MhnsInsightsOrganizationHealthInsightCounts",
  "V2MhnsInsightsTerminalBundle",
  "V2MhnsInsightsTerminalBundlesDeprecatedPayload",
  "V2MhnsInsightsTerminalBundlesReleasedPayload",
  "V2MhnsInsightsTerminalDeviceTypeBundles",
  "V2MhnsInsightsTerminalSkuAvailabilityPayload",
  "V2MhnsInsightsTerminalSoftwareRolloutStartedPayload",
  "V2MoneyManagementClaimsListClaimsResponse",
  "V2NetworkTokensNetworkTokenCryptogram",
  "V2OAuthApproveDeviceAuthorizationResponse",
  "V2OAuthListServicePrincipalsResponse",
  "V2OAuthListTrustedWorkloadProvidersResponse",
  "V2OAuthOAuthCompartmentGrant",
  "V2OAuthPermission",
  "V2OAuthRetrieveOAuthSessionsByUserAndCompartmentResponse",
  "V2OAuthRetrieveOAuthSessionsResponse",
  "V2OAuthRevokeAllClientOAuthSessionsResponse",
  "V2OAuthRevokeClientOAuthSessionByCompartmentResponse",
  "V2OAuthRevokeClientOAuthSessionResponse",
  "V2OAuthValidateTrustedWorkloadProviderConfigurationResponse",
  "V2OAuthVerifyDeviceUserCodeResponse",
  "V2ObjectDefinitionGroupsAppClassifySchemaBumpForApiResponse",
  "V2ObjectDefinitionGroupsAppDefinitionClassification",
  "V2ObjectDefinitionGroupsAppSchemaBumpFieldChange",
  "V2ObjectDefinitionsDashboardDashboardListObjectDefinitionsResponse",
  "V2ObjectDefinitionsDashboardObjectReferenceDetails",
  "V2ObjectDefinitionsDefaultValue",
  "V2ObjectDefinitionsFieldSchema",
  "V2ObjectDefinitionsListObjectDefinitionGroupVersionsResponse",
  "V2ObjectDefinitionsListObjectDefinitionGroupsResponse",
  "V2ObjectDefinitionsListObjectDefinitionVersionsResponse",
  "V2ObjectDefinitionsListObjectDefinitionsResponse",
  "V2ObjectDefinitionsMonetaryAmountDefault",
  "V2ObjectDefinitionsPropertiesEntry",
  "V2ObjectDefinitionsValueBoundary",
  "V2ObjectRecordsDashboardDashboardRetrieveObjectRecordResponse",
  "V2ObjectRecordsDashboardObjectReferenceDetails",
  "V2ObjectRecordsDeleteAllObjectRecordResponse",
  "V2ObjectRecordsInvokeObjectRecordMethodResponse",
  "V2ObjectRecordsListObjectRecordResponse",
  "V2ObjectRecordsListRelatedObjectRecordsInternalResponse",
  "V2ObjectRecordsSearchObjectRecordResponse",
  "V2OffSessionPaymentsCaptureDetailsResource",
  "V2OffSessionPaymentsLatestPaymentAttemptRecordCardDetails",
  "V2OffSessionPaymentsLatestPaymentAttemptRecordDetails",
  "V2OffSessionPaymentsLatestPaymentAttemptRecordFailureDetails",
  "V2OffSessionPaymentsLatestPaymentAttemptRecordPaymentMethodDetails",
  "V2OffSessionPaymentsLatestPaymentAttemptRecordProcessorDetails",
  "V2OffSessionPaymentsLatestPaymentAttemptRecordStripeProcessorDetails",
  "V2OffSessionPaymentsListOffSessionPaymentsResponse",
  "V2OffSessionPaymentsMetadataEntry",
  "V2OffSessionPaymentsOffSessionPaymentsAmountDetailsError",
  "V2OffSessionPaymentsOffSessionPaymentsAmountDetailsLineItemResource",
  "V2OffSessionPaymentsOffSessionPaymentsAmountDetailsResource",
  "V2OffSessionPaymentsOffSessionPaymentsAmountDetailsShippingResource",
  "V2OffSessionPaymentsOffSessionPaymentsAmountDetailsTaxResource",
  "V2OffSessionPaymentsOffSessionPaymentsPaymentDetailsResource",
  "V2OffSessionPaymentsPaymentsOrchestrationResource",
  "V2OffSessionPaymentsRetryDetailsResource",
  "V2OffSessionPaymentsTransferData",
  "V2OrgSupportConversationsListOrgSupportConversationsResponse",
  "V2OutboundPaymentsAddress",
  "V2OutboundPaymentsBankAccountTrackingDetails",
  "V2OutboundPaymentsCardTrackingDetails",
  "V2OutboundPaymentsCheckSendTrackingDetails",
  "V2OutboundPaymentsCryptoWalletTrackingDetails",
  "V2OutboundPaymentsFrom",
  "V2OutboundPaymentsFxqRate",
  "V2OutboundPaymentsInternalAmountsEntry",
  "V2OutboundPaymentsInternalCurrencyAmountMap",
  "V2OutboundPaymentsInternalCurrencyFeeEstimateMap",
  "V2OutboundPaymentsInternalCurrencyFxEstimateMap",
  "V2OutboundPaymentsInternalCurrencyList",
  "V2OutboundPaymentsInternalDestinationCountryCurrenciesEntry",
  "V2OutboundPaymentsInternalDestinationCountryFeeEstimatesEntry",
  "V2OutboundPaymentsInternalDestinationCountryFxEstimatesEntry",
  "V2OutboundPaymentsInternalDestinationCountryMaxAmountsEntry",
  "V2OutboundPaymentsInternalDestinationCountryMinAmountsEntry",
  "V2OutboundPaymentsInternalDestinationCountryNamesEntry",
  "V2OutboundPaymentsInternalFeeComponent",
  "V2OutboundPaymentsInternalFeeEstimate",
  "V2OutboundPaymentsInternalFeeEstimatesEntry",
  "V2OutboundPaymentsInternalFxEstimate",
  "V2OutboundPaymentsInternalFxEstimatesEntry",
  "V2OutboundPaymentsInternalMaxAmountByCurrencyEntry",
  "V2OutboundPaymentsInternalMaxAmountOverrideByCurrencyEntry",
  "V2OutboundPaymentsInternalMinAmountByCurrencyEntry",
  "V2OutboundPaymentsInternalNetworkConfig",
  "V2OutboundPaymentsInternalNetworkQuote",
  "V2OutboundPaymentsInternalPaymentMethodConfig",
  "V2OutboundPaymentsInternalQuotesEntry",
  "V2OutboundPaymentsInternalRetrieveOutboundPaymentsConfigResponse",
  "V2OutboundPaymentsInternalSenderCountryConfig",
  "V2OutboundPaymentsListOutboundPaymentsResponse",
  "V2OutboundPaymentsNetworkFeeAchOptions",
  "V2OutboundPaymentsNetworkFeeDetails",
  "V2OutboundPaymentsNetworkFeeOptions",
  "V2OutboundPaymentsObpAchNetworkOptions",
  "V2OutboundPaymentsObpBankAccountPayoutMethodOptions",
  "V2OutboundPaymentsObpCheckSendPayoutMethodOptions",
  "V2OutboundPaymentsObpDeliveryOptions",
  "V2OutboundPaymentsObpMethod",
  "V2OutboundPaymentsObpPayoutMethodOptions",
  "V2OutboundPaymentsObpPreferredNetworkOptions",
  "V2OutboundPaymentsObpTrackingDetails",
  "V2OutboundPaymentsObpqDeliveryOptions",
  "V2OutboundPaymentsObpqEstimatedFees",
  "V2OutboundPaymentsObpqFrom",
  "V2OutboundPaymentsObpqFxq",
  "V2OutboundPaymentsObpqTaxAmount",
  "V2OutboundPaymentsObpqTo",
  "V2OutboundPaymentsOutboundPaymentFailedStatusDetailsReason",
  "V2OutboundPaymentsOutboundPaymentProcessingStatusDetailsReason",
  "V2OutboundPaymentsOutboundPaymentStatusDetails",
  "V2OutboundPaymentsOutboundPaymentStatusTransitions",
  "V2OutboundPaymentsPaperCheckDeliveryOptions",
  "V2OutboundPaymentsPaperCheckTrackingDetails",
  "V2OutboundPaymentsRatesEntry",
  "V2OutboundPaymentsRecipientNotification",
  "V2OutboundPaymentsReturnedStatusDetailsReason",
  "V2OutboundPaymentsTo",
  "V2OutboundPaymentsTraceId",
  "V2OutboundSetupIntentsAddress",
  "V2OutboundSetupIntentsConfirmationOfPayee",
  "V2OutboundSetupIntentsListOutboundSetupIntentsResponse",
  "V2OutboundSetupIntentsNextAction",
  "V2OutboundSetupIntentsPayoutMethodApplePay",
  "V2OutboundSetupIntentsPayoutMethodBankAccount",
  "V2OutboundSetupIntentsPayoutMethodCard",
  "V2OutboundSetupIntentsPayoutMethodCheckSend",
  "V2OutboundSetupIntentsPayoutMethodCryptoWallet",
  "V2OutboundSetupIntentsPayoutMethodNetworkBusinessProfileWallet",
  "V2OutboundSetupIntentsPayoutMethodPix",
  "V2OutboundSetupIntentsUsageStatus",
  "V2OutboundTransfersFailedStatusDetailsReason",
  "V2OutboundTransfersListOutboundTransfersResponse",
  "V2OutboundTransfersObtAchNetworkOptions",
  "V2OutboundTransfersObtBankAccountPayoutMethodOptions",
  "V2OutboundTransfersObtDeliveryOptions",
  "V2OutboundTransfersObtFrom",
  "V2OutboundTransfersObtMethod",
  "V2OutboundTransfersObtPayoutMethodOptions",
  "V2OutboundTransfersObtPreferredNetworkOptions",
  "V2OutboundTransfersObtToResponse",
  "V2OutboundTransfersOutboundTransferStatusTransitions",
  "V2OutboundTransfersProcessingStatusDetailsReason",
  "V2OutboundTransfersReturnedStatusDetailsReason",
  "V2OutboundTransfersStatusDetails",
  "V2OutboundTransfersTraceId",
  "V2OzoneAuthorizationsAccountInformationConsentDetails",
  "V2OzoneAuthorizationsConfirmOzoneAuthorizationResponse",
  "V2OzoneAuthorizationsConsentDetails",
  "V2OzoneAuthorizationsDomesticPaymentsConsentDetails",
  "V2OzoneAuthorizationsGetOzoneAuthorizationResponse",
  "V2OzoneAuthorizationsGetRecipientInformationResponse",
  "V2OzoneAuthorizationsHaltInteraction",
  "V2OzoneAuthorizationsMatchResultDetails",
  "V2OzoneAuthorizationsOutboundPaymentFee",
  "V2OzoneAuthorizationsPartnerError",
  "V2OzoneAuthorizationsPaymentAccount",
  "V2OzoneAuthorizationsRecipientVerificationConsumedBy",
  "V2OzoneAuthorizationsRecipientVerificationStatusTransitions",
  "V2OzoneAuthorizationsRejectOzoneAuthorizationResponse",
  "V2OzoneAuthorizationsThirdPartyProvider",
  "V2PaymentMethodsGbBankAccountsGbBankAccountConfirmationOfPayee",
  "V2PaymentMethodsGbBankAccountsGbBankAccountConfirmationOfPayeeResult",
  "V2PaymentMethodsGbBankAccountsListGbBankAccountsResponse",
  "V2PaymentMethodsGbBankAccountsMatched",
  "V2PaymentMethodsGbBankAccountsProvided",
  "V2PaymentMethodsPaymentMethodsAddress",
  "V2PaymentMethodsPaymentMethodsBankAccountCountrySpec",
  "V2PaymentMethodsPaymentMethodsBankAccountCountrySpecField",
  "V2PaymentMethodsPaymentMethodsBankAccountVerification",
  "V2PaymentMethodsPaymentMethodsCardBillingDetails",
  "V2PaymentMethodsPaymentMethodsCountriesEntry",
  "V2PaymentMethodsPaymentMethodsCurrencies",
  "V2PaymentMethodsPaymentMethodsDestinationApplePay",
  "V2PaymentMethodsPaymentMethodsDestinationBankAccount",
  "V2PaymentMethodsPaymentMethodsDestinationCard",
  "V2PaymentMethodsPaymentMethodsDestinationCheckSend",
  "V2PaymentMethodsPaymentMethodsDestinationCryptoWallet",
  "V2PaymentMethodsPaymentMethodsDestinationLink",
  "V2PaymentMethodsPaymentMethodsDestinationNetworkBusinessProfileWallet",
  "V2PaymentMethodsPaymentMethodsDestinationPix",
  "V2PaymentMethodsPaymentMethodsEligibilityReason",
  "V2PaymentMethodsPaymentMethodsFlows",
  "V2PaymentMethodsPaymentMethodsListOffSessionSourcesResponse",
  "V2PaymentMethodsPaymentMethodsListOnSessionSourcesResponse",
  "V2PaymentMethodsPaymentMethodsListOutboundDestinationsResponse",
  "V2PaymentMethodsPaymentMethodsMicrodepositVerificationDetails",
  "V2PaymentMethodsPaymentMethodsOutbound",
  "V2PaymentMethodsPaymentMethodsOutboundDestinationBankAccountSpecResponse",
  "V2PaymentMethodsUsBankAccountsBankAccountVerification",
  "V2PaymentMethodsUsBankAccountsListUsBankAccountsResponse",
  "V2PaymentMethodsUsBankAccountsMicrodepositVerificationDetails",
  "V2PaymentReservationsListPaymentReservationsResponse",
  "V2PaymentRetryEvaluationRecommendation",
  "V2PayoutIntentsConfirm",
  "V2PayoutIntentsHandleFailure",
  "V2PayoutIntentsLatestPayout",
  "V2PayoutIntentsLatestPayoutError",
  "V2PayoutIntentsListPayoutIntentsResponse",
  "V2PayoutIntentsNetworkFeeAchOptions",
  "V2PayoutIntentsNetworkFeeDetails",
  "V2PayoutIntentsNetworkFeeOptions",
  "V2PayoutIntentsNextAction",
  "V2PayoutIntentsPaperCheckDeliveryOptions",
  "V2PayoutIntentsPayoutIntentAchNetworkOptions",
  "V2PayoutIntentsPayoutIntentBankAccountPayoutMethodOptions",
  "V2PayoutIntentsPayoutIntentDeliveryOptions",
  "V2PayoutIntentsPayoutIntentEstimatedFee",
  "V2PayoutIntentsPayoutIntentFromResponse",
  "V2PayoutIntentsPayoutIntentFxQuote",
  "V2PayoutIntentsPayoutIntentFxQuoteRate",
  "V2PayoutIntentsPayoutIntentPayoutMethodOptions",
  "V2PayoutIntentsPayoutIntentPreferredNetworkOptions",
  "V2PayoutIntentsPayoutIntentRecipientVerification",
  "V2PayoutIntentsPayoutIntentRecipientVerificationMatchResultDetails",
  "V2PayoutIntentsPayoutIntentStatusTransitions",
  "V2PayoutIntentsPayoutIntentTaxAmount",
  "V2PayoutIntentsPayoutIntentToWithExpansions",
  "V2PayoutIntentsRatesEntry",
  "V2PayoutIntentsRecipientNotification",
  "V2PayoutIntentsScheduleOptions",
  "V2PayoutMethodsAddress",
  "V2PayoutMethodsBankAccountSpecCountry",
  "V2PayoutMethodsBankAccountSpecCountryField",
  "V2PayoutMethodsCountriesEntry",
  "V2PayoutMethodsCurrencies",
  "V2PayoutMethodsListPayoutMethodsResponse",
  "V2PayoutMethodsPayoutMethodApplePay",
  "V2PayoutMethodsPayoutMethodBankAccount",
  "V2PayoutMethodsPayoutMethodCard",
  "V2PayoutMethodsPayoutMethodCheckSend",
  "V2PayoutMethodsPayoutMethodCryptoWallet",
  "V2PayoutMethodsPayoutMethodNetworkBusinessProfileWallet",
  "V2PayoutMethodsPayoutMethodPix",
  "V2PayoutMethodsPayoutMethodsBankAccountSpec",
  "V2PayoutMethodsUsageStatus",
  "V2PayphonePrivatePaymentIntentConfirmResponse",
  "V2PayphonePrivateSetupIntentConfirmResponse",
  "V2PayphoneVoiceSessionFailureDetails",
  "V2PayphoneVoiceSessionSipTransferTarget",
  "V2PayphoneVoiceSessionTelephoneTransferTarget",
  "V2PayphoneVoiceSessionTransferTargets",
  "V2PayphoneVoiceSessionTwilioApplicationParameter",
  "V2PayphoneVoiceSessionTwilioApplicationTransferTarget",
  "V2PersonsPersonalAddressField",
  "V2PersonsPersonalAddressLabelsField",
  "V2PersonsPersonalIdNumberField",
  "V2PersonsPersonalNameField",
  "V2PersonsPersonalNameLabelsField",
  "V2ProgramsCreateProgramResponse",
  "V2ProgramsGetProgramResponse",
  "V2ProgramsSimulatePreviousEarningPeriodTestHelperResponse",
  "V2ProgramsUpdateProgramResponse",
  "V2ProposalCreateProposalResponse",
  "V2ProposalProposal",
  "V2ProposalRetrieveProposalsResponse",
  "V2ProvisioningCollectKycResponse",
  "V2ProvisioningComponentOption",
  "V2ProvisioningComponentPricing",
  "V2ProvisioningCreateDeepLinkInternalResponse",
  "V2ProvisioningCreateDeepLinkResponse",
  "V2ProvisioningCreatePaymentMethodRequestInternalResponse",
  "V2ProvisioningEligibility",
  "V2ProvisioningEnvironmentResourceAccessConfiguration",
  "V2ProvisioningError",
  "V2ProvisioningIdentityActor",
  "V2ProvisioningIdentityProjectOwner",
  "V2ProvisioningInternalListProvidersInternalResponse",
  "V2ProvisioningInternalProviderListingInternal",
  "V2ProvisioningInternalProviderLiveListingVersionInternal",
  "V2ProvisioningListCatalogProvidersInternalResponse",
  "V2ProvisioningListCatalogProvidersResponse",
  "V2ProvisioningListCatalogServicesInternalResponse",
  "V2ProvisioningListCatalogServicesResponse",
  "V2ProvisioningListChargesInternalResponse",
  "V2ProvisioningListChargesResponse",
  "V2ProvisioningListFeaturesInternalResponse",
  "V2ProvisioningListFeaturesResponse",
  "V2ProvisioningListProjectVariablesInternalResponse",
  "V2ProvisioningListProjectVariablesResponse",
  "V2ProvisioningListProjectsInternalResponse",
  "V2ProvisioningListProjectsResponse",
  "V2ProvisioningListProviderConnectionsInternalResponse",
  "V2ProvisioningListProviderConnectionsResponse",
  "V2ProvisioningListProvidersResponse",
  "V2ProvisioningListResourcesInternalResponse",
  "V2ProvisioningListResourcesResponse",
  "V2ProvisioningListServicesResponse",
  "V2ProvisioningPaidPricing",
  "V2ProvisioningPaymentMethodRequest",
  "V2ProvisioningPaymentProfile",
  "V2ProvisioningPrepareProjectsAccessInternalResponse",
  "V2ProvisioningPrepareProjectsAccessResponse",
  "V2ProvisioningProjectProfileSummary",
  "V2ProvisioningProviderAccountActiveService",
  "V2ProvisioningProviderPaymentDetails",
  "V2ProvisioningProviderServiceAllowedUpdate",
  "V2ProvisioningProviderServiceConstraint",
  "V2ProvisioningProviderServiceCountConstraint",
  "V2ProvisioningProviderServicePricing",
  "V2ProvisioningProviderUsage",
  "V2ProvisioningProviderUserMessage",
  "V2ProvisioningPushError",
  "V2ProvisioningPushListPublicKeysResponse",
  "V2ProvisioningPushPaymentCredentials",
  "V2ProvisioningPushProviderAccountActiveService",
  "V2ProvisioningPushPublicKey",
  "V2ProvisioningPushRetrievePaymentCredentialsResponse",
  "V2ProvisioningRetrieveEligibilityInternalResponse",
  "V2ProvisioningRetrieveEnvironmentInfoInternalResponse",
  "V2ProvisioningRetrieveEnvironmentInfoResponse",
  "V2ProvisioningRetrieveIdentityInternalResponse",
  "V2ProvisioningRetrieveIdentityResponse",
  "V2ProvisioningRetrieveProviderChargesInternalResponse",
  "V2ProvisioningRetrieveProviderChargesResponse",
  "V2ProvisioningSettingsEntry",
  "V2ProvisioningTopLevelPaidPricing",
  "V2ProvisioningUsageCharge",
  "V2ProvisioningUsageLimits",
  "V2ReceivedCreditsABABankAccount",
  "V2ReceivedCreditsAUBankAccount",
  "V2ReceivedCreditsAchNetworkDetails",
  "V2ReceivedCreditsAtlasInvestmentObject",
  "V2ReceivedCreditsBSBBankAccount",
  "V2ReceivedCreditsBalanceTransferObject",
  "V2ReceivedCreditsBankCodeBankAccount",
  "V2ReceivedCreditsBankTransferCreditObject",
  "V2ReceivedCreditsCABankAccount",
  "V2ReceivedCreditsCLABEBankAccount",
  "V2ReceivedCreditsCPABankAccount",
  "V2ReceivedCreditsCardSpendCreditObject",
  "V2ReceivedCreditsCryptoWallet",
  "V2ReceivedCreditsCryptoWalletTransferObject",
  "V2ReceivedCreditsDispute",
  "V2ReceivedCreditsEUBankAccount",
  "V2ReceivedCreditsGBBankAccount",
  "V2ReceivedCreditsIBANBankAccount",
  "V2ReceivedCreditsListReceivedCreditsResponse",
  "V2ReceivedCreditsMXBankAccount",
  "V2ReceivedCreditsNetworkDetails",
  "V2ReceivedCreditsOriginatingBankAccount",
  "V2ReceivedCreditsReceivedCreditStatusDetails",
  "V2ReceivedCreditsReceivedCreditStatusDetailsFailedReason",
  "V2ReceivedCreditsReceivedCreditStatusDetailsReturnedReason",
  "V2ReceivedCreditsReceivedCreditStatusTransitions",
  "V2ReceivedCreditsRefund",
  "V2ReceivedCreditsSEPABankAccount",
  "V2ReceivedCreditsSortCodeBankAccount",
  "V2ReceivedCreditsStripeBalancePaymentCreditObject",
  "V2ReceivedCreditsStripeNetworkTransferFrom",
  "V2ReceivedCreditsStripeNetworkTransferObject",
  "V2ReceivedCreditsUSBankAccount",
  "V2ReceivedDebitMandatesListReceivedDebitMandatesResponse",
  "V2ReceivedDebitMandatesReceivedDebitMandateBankTransferAch",
  "V2ReceivedDebitMandatesReceivedDebitMandateBankTransferObject",
  "V2ReceivedDebitMandatesReceivedDebitMandateStatusDetails",
  "V2ReceivedDebitMandatesReceivedDebitMandateStatusDetailsCanceled",
  "V2ReceivedDebitMandatesReceivedDebitMandateStatusTransitions",
  "V2ReceivedDebitsAchNetworkDetails",
  "V2ReceivedDebitsAuthorization",
  "V2ReceivedDebitsBalanceTransferDebitObject",
  "V2ReceivedDebitsBankTransferDebitObject",
  "V2ReceivedDebitsBankTransferNetworkDetails",
  "V2ReceivedDebitsCardSpendObject",
  "V2ReceivedDebitsCardTransaction",
  "V2ReceivedDebitsExternalDebitObject",
  "V2ReceivedDebitsGbBankAccount",
  "V2ReceivedDebitsListReceivedDebitsResponse",
  "V2ReceivedDebitsReceivedDebitDisputeDetails",
  "V2ReceivedDebitsReceivedDebitStatusDetails",
  "V2ReceivedDebitsReceivedDebitStatusDetailsFailedReason",
  "V2ReceivedDebitsReceivedDebitStatusDetailsReturnedReason",
  "V2ReceivedDebitsReceivedDebitStatusTransitions",
  "V2ReceivedDebitsStripeBalancePaymentDebitObject",
  "V2ReceivedDebitsUsBankAccount",
  "V2RecipientPayoutsAcknowledgePaymentMethodCoPForRelatedPayoutLinksResponse",
  "V2RecipientPayoutsCheckRecipientLinkAccountEligibilityResponse",
  "V2RecipientPayoutsCheckRecipientLinkSignupEligibilityResponse",
  "V2RecipientPayoutsPayoutLinkToParams",
  "V2RecipientPayoutsSendRecipientPayoutResponse",
  "V2RecipientVerificationsListRecipientVerificationsResponse",
  "V2RecipientVerificationsMatchResultDetails",
  "V2RecipientVerificationsRecipientVerificationConsumedBy",
  "V2RecipientVerificationsRecipientVerificationStatusTransitions",
  "V2ReportingArrayDetails",
  "V2ReportingEnumDetails",
  "V2ReportingExternalUrl",
  "V2ReportingFile",
  "V2ReportingInline",
  "V2ReportingListReportsResponse",
  "V2ReportingMetadata",
  "V2ReportingParameterValue",
  "V2ReportingParametersEntry",
  "V2ReportingQueryDetails",
  "V2ReportingQueryRunStatusDetails",
  "V2ReportingQueryRunStatusDetailsEntry",
  "V2ReportingReportParameters",
  "V2ReportingReportParametersEntry",
  "V2ReportingReportRunStatusDetails",
  "V2ReportingResult",
  "V2ReportingResultColumn",
  "V2ReportingResultOptions",
  "V2ReportingResultSchema",
  "V2ReportingResultValue",
  "V2ReportingRow",
  "V2ReportingRowEntry",
  "V2ReportingStatusDetailsEntry",
  "V2ReportingStringArray",
  "V2ReportingTimestampDetails",
  "V2RequirementsEntry",
  "V2RequirementsEntryDeadline",
  "V2RequirementsEntryImpact",
  "V2RequirementsError",
  "V2RequirementsGetRequirementsResponse",
  "V2RequirementsTimeBasedDeadline",
  "V2RevenueContractGetRevenueContractByAgreementReferenceResponse",
  "V2RevenueContractGetRevenueContractByDeliveryReferenceResponse",
  "V2RevenueTreatmentItemMappingListRevenueTreatmentItemMappingVersionsResponse",
  "V2RevenueTreatmentItemMappingListRevenueTreatmentItemMappingsResponse",
  "V2RevenueTreatmentItemMappingRevenueTreatmentVersionMetadata",
  "V2RevenueTreatmentListRevenueTreatmentVersionsResponse",
  "V2RevenueTreatmentListRevenueTreatmentsResponse",
  "V2RevenueTreatmentRevenueTreatmentAccountMapping",
  "V2RevenueTreatmentRevenueTreatmentVersionMetadata",
  "V2RewardManagementListRewardProgramEnrollmentsResponse",
  "V2RewardManagementListRewardProgramRulesResponse",
  "V2RewardManagementListRewardProgramsResponse",
  "V2RewardManagementRewardProgramEnrollmentCardSpend",
  "V2RewardManagementRewardProgramRuleCardSpendCondition",
  "V2RewardManagementRewardProgramRuleCashback",
  "V2RewardManagementRewardProgramRuleCondition",
  "V2RewardManagementRewardProgramRuleMerchantCategoryCodes",
  "V2RewardManagementRewardProgramRuleReward",
  "V2RewardsInternalGetProgramDetailsResponse",
  "V2RewardsInternalRate",
  "V2RiskVtwoAccountActivityAccountRestricted",
  "V2RiskVtwoAccountActivityAccountReviewed",
  "V2RiskVtwoAccountActivityAccountSuspended",
  "V2RiskVtwoAccountActivityAttempt",
  "V2RiskVtwoAccountActivityDecision",
  "V2RiskVtwoAccountData",
  "V2RiskVtwoAccountDetails",
  "V2RiskVtwoAccountEvaluationAccountDetails",
  "V2RiskVtwoBusinessDetails",
  "V2RiskVtwoClientData",
  "V2RiskVtwoClientDetailsData",
  "V2RiskVtwoDefaultsData",
  "V2RiskVtwoFraudulentMerchantIndicator",
  "V2RiskVtwoFraudulentMerchantSignal",
  "V2RiskVtwoFraudulentMerchantSignalAdditionalDetails",
  "V2RiskVtwoFraudulentWebsiteSignal",
  "V2RiskVtwoIdentityData",
  "V2RiskVtwoListAccountSignalsResponse",
  "V2RiskVtwoMerchantDelinquencyIndicator",
  "V2RiskVtwoMerchantDelinquencySignal",
  "V2RiskVtwoMerchantDelinquencySignalAdditionalDetails",
  "V2RiskVtwoPaymentDelinquencyExposureAdditionalDetails",
  "V2RiskVtwoPaymentDelinquencyExposureAmount",
  "V2RiskVtwoPaymentDelinquencyExposureSignal",
  "V2RiskVtwoProfileData",
  "V2RiskVtwoUserAccountSharingSignal",
  "V2RiskVtwoUserMultiAccountingSignal",
  "V2RoleAssignmentsGetRoleAssignmentsResponse",
  "V2RoleAssignmentsRevokeAllAccessResponse",
  "V2RoleAssignmentsRoleAssignment",
  "V2RoleAssignmentsRoleAssignmentRevocationResult",
  "V2RoleAssignmentsSetUserRoleAssignmentsInCompartmentsResponse",
  "V2RoleAssignmentsUserRoleAssignment",
  "V2RolesAssignableRoles",
  "V2RolesGetAssignableRolesResponse",
  "V2RubyLlamaDeprecatedMetadataEntry",
  "V2RubyLlamaRetrieveRubyLlamaAccessConditionTestResponse",
  "V2RubyLlamaRetrieveRubyLlamaCompartmentResponse",
  "V2RubyLlamaRetrieveRubyLlamaRolloutConfigTestResponse",
  "V2SandboxRegisterSandboxResponse",
  "V2SandboxesChildLimits",
  "V2SandboxesCompartmentLimits",
  "V2SandboxesGetNearestPlaygroundIdResponse",
  "V2SandboxesGetUserAccessibleReparentableSandboxesResponse",
  "V2SandboxesReparentableSandbox",
  "V2SandboxesRubyClaimableSandboxKeys",
  "V2SandboxesRubyFailureCopiedDetailsEntry",
  "V2SandboxesRubyGetOnboardingSandboxStatusResponse",
  "V2SandboxesRubyGetTestmodeStatusFromContextResponse",
  "V2SandboxesRubyGrouping",
  "V2SandboxesRubyInstallAppOnLivemodeResponse",
  "V2SandboxesRubyListIdMappingsResponse",
  "V2SandboxesRubyListResourceCopyRecordsResponse",
  "V2SandboxesRubyObjectList",
  "V2SandboxesRubyOnboardingLinkDetails",
  "V2SandboxesRubyOwnerDetails",
  "V2SandboxesRubyPrefillResponse",
  "V2SandboxesRubyRetrieveBulkCopyOperationResponse",
  "V2SandboxesRubyRetrieveClaimMetadataResponse",
  "V2SandboxesRubyRetrieveClaimableSandboxStatusResponse",
  "V2SandboxesRubyRetrieveMetadataFromClaimSignatureResponse",
  "V2SandboxesRubySandboxDetails",
  "V2SandboxesRubySkipCopiedDetailsEntry",
  "V2SandboxesRubySuccessCopiedDetailsEntry",
  "V2SandboxesUpdateOrganizationSandboxAccessLevelResponse",
  "V2SandboxesUpdateSandboxAccessLevelResponse",
  "V2ScimConfigScimMergeConflict",
  "V2ScimConfigValidateMergeScimConflictsResponse",
  "V2ScriptControlPlaneExtensionDefinedErrorDetails",
  "V2ScriptControlPlaneGetScriptRunResponse",
  "V2ScriptControlPlaneRateLimitDetails",
  "V2ScriptControlPlaneScriptLog",
  "V2ScriptControlPlaneScriptRunFailedDetails",
  "V2ScriptControlPlaneScriptRunStatusDetails",
  "V2ScriptControlPlaneTimeoutDetails",
  "V2SdbDatabaseConnection",
  "V2SdbListDatabaseUsersResponse",
  "V2SdbListDatabasesResponse",
  "V2SdbSyncObject",
  "V2SecurityEventsApiKeyDetails",
  "V2SecurityEventsGeoData",
  "V2SecurityEventsHumanReadable",
  "V2SecurityEventsOwningCompartmentInfo",
  "V2SecurityEventsRequestDetails",
  "V2SecurityEventsSearchSecurityEventsResponse",
  "V2SettingsDefaultAccountMappings",
  "V2SettingsListSettingsVersionsResponse",
  "V2SettlementAllocationIntentListSettlementAllocationIntentsResponse",
  "V2SettlementAllocationIntentSettlementAllocationIntentStatusDetails",
  "V2SettlementAllocationIntentSettlementAllocationIntentStatusDetailsErroredReason",
  "V2SettlementAllocationIntentSplitFlow",
  "V2SettlementAllocationIntentSplitListSettlementAllocationIntentSplitsResponse",
  "V2SpendRequestApprovalDetails",
  "V2SpendRequestBillingAddress",
  "V2SpendRequestCardDetails",
  "V2SpendRequestLineItem",
  "V2SpendRequestTotal",
  "V2StaxRubyPlaygroundBulkUpdateStaxRubyRecordsResponse",
  "V2StaxRubyPlaygroundDeleteStaxCrossModeSharedConfigResponse",
  "V2StaxRubyPlaygroundListStaxRubyModelsResponse",
  "V2StaxRubyPlaygroundListStaxRubyTenantMigrationRecordsResponse",
  "V2StaxRubyPlaygroundMetadataEntry",
  "V2StaxRubyPlaygroundTenantId",
  "V2StaxRubyPlaygroundVerifyStaxRubyAtomicBatchWriteResponse",
  "V2StaxRubyPlaygroundVerifyStaxRubyMutatorSessionResponse",
  "V2StaxRubyPlaygroundVerifyStaxRubyOptimisticLockingResponse",
  "V2StaxRubyPlaygroundVerifyStaxRubyPessimisticLockingResponse",
  "V2StaxRubyPlaygroundVerifyStaxRubyReadPathsResponse",
  "V2StaxRubyPlaygroundVerifyStaxRubySnapshotReadsResponse",
  "V2StripeSyncBackfillStreamResource",
  "V2StripeSyncDestination",
  "V2StripeSyncExchangeOAuthTokenResponse",
  "V2StripeSyncGetOAuthUrlResponse",
  "V2StripeSyncGoogleSheetsResource",
  "V2StripeSyncListAvailableDestinationsResponse",
  "V2StripeSyncListPipelinesResponse",
  "V2StripeSyncListProjectsResponse",
  "V2StripeSyncListStreamsResponse",
  "V2StripeSyncMetadataEntry",
  "V2StripeSyncPostgresResource",
  "V2StripeSyncPostgresViaProviderResource",
  "V2StripeSyncTestConnectionResponse",
  "V2SuggestedBrandingRetrieveSuggestedBrandingResponse",
  "V2TaxCalculationV2CustomerDetails",
  "V2TaxCalculationV2FlatAmount",
  "V2TaxCalculationV2Jurisdiction",
  "V2TaxCalculationV2LineItemTaxBreakdown",
  "V2TaxCalculationV2LineItemTaxRateDetails",
  "V2TaxCalculationV2PerformanceLocationDetails",
  "V2TaxCalculationV2PostalAddress",
  "V2TaxCalculationV2ShipFromDetails",
  "V2TaxCalculationV2TaxBreakdown",
  "V2TaxCalculationV2TaxCalculationLineItemList",
  "V2TaxCalculationV2TaxCalculationShippingCost",
  "V2TaxCalculationV2TaxId",
  "V2TaxCalculationV2TaxRateDetails",
  "V2TaxManualRulesListManualRulesResponse",
  "V2TaxManualRulesLocation",
  "V2TaxManualRulesProduct",
  "V2TaxManualRulesScheduledTaxRates",
  "V2TaxManualRulesTaxRate",
  "V2TaxTaxCalculationsCustomerDetails",
  "V2TaxTaxCalculationsFlatAmount",
  "V2TaxTaxCalculationsJurisdiction",
  "V2TaxTaxCalculationsLineItemTaxBreakdown",
  "V2TaxTaxCalculationsLineItemTaxRateDetails",
  "V2TaxTaxCalculationsPerformanceLocationDetails",
  "V2TaxTaxCalculationsPostalAddress",
  "V2TaxTaxCalculationsShipFromDetails",
  "V2TaxTaxCalculationsTaxBreakdown",
  "V2TaxTaxCalculationsTaxCalculationLineItemList",
  "V2TaxTaxCalculationsTaxCalculationShippingCost",
  "V2TaxTaxCalculationsTaxId",
  "V2TaxTaxCalculationsTaxRateDetails",
  "V2TaxTaxIntegrationConfigurationCheckoutSessionsConfiguration",
  "V2TaxTaxIntegrationConfigurationIntegrationConfiguration",
  "V2TaxTaxIntegrationConfigurationInvoicesConfiguration",
  "V2TaxTaxOperationsAddressOutput",
  "V2TaxTaxOperationsOperationsResolveAddressResult",
  "V2TaxTaxOperationsPrecisionDetails",
  "V2TaxTaxOperationsPrecisionIssue",
  "V2TransactionsBalanceImpact",
  "V2TransactionsCounterparty",
  "V2TransactionsFlow",
  "V2TransactionsFundsAvailability",
  "V2TransactionsListTransactionEntriesResponse",
  "V2TransactionsListTransactionsResponse",
  "V2TransactionsRegulatoryReceipt",
  "V2TransactionsRetrieveAllDashboardTransactionsResponse",
  "V2TransactionsSearchTransactionsResponse",
  "V2TransactionsStatusTransitions",
  "V2TransactionsTransactionEntryTransactionDetails",
  "V2UnifiedQueryDataEntry",
  "V2UnifiedQueryExternalUrl",
  "V2UnifiedQueryListCatalogsResponse",
  "V2UnifiedQueryListTablesResponse",
  "V2UnifiedQueryQueryResult",
  "V2UnifiedQueryQueryResultColumn",
  "V2UnifiedQueryQueryResultFile",
  "V2UnifiedQueryQueryResultInline",
  "V2UnifiedQueryQueryResultRow",
  "V2UnifiedQueryQueryResultValue",
  "V2UnifiedQueryQueryStatusDetails",
  "V2UnifiedQueryTableColumn",
  "V2UserFacingFunctionalityAdditionalFeatureReference",
  "V2UserFacingFunctionalityCancelFeatureConfigurationIntentResponse",
  "V2UserFacingFunctionalityConnectStatus",
  "V2UserFacingFunctionalityCreateFeatureConfigurationIntentResponse",
  "V2UserFacingFunctionalityEnabled",
  "V2UserFacingFunctionalityExecuteFeatureConfigurationIntentActionResponse",
  "V2UserFacingFunctionalityExecuteFeatureConfigurationIntentWorkflowResponse",
  "V2UserFacingFunctionalityFeatureConfigurationIntentCancelledDetails",
  "V2UserFacingFunctionalityFeatureConfigurationIntentInitialStateDetails",
  "V2UserFacingFunctionalityFeatureConfigurationIntentPreInitializeDetails",
  "V2UserFacingFunctionalityFeatureConfigurationIntentStatusUpdatedDetails",
  "V2UserFacingFunctionalityFeatureConfigurationIntentToEnableCreatedDetails",
  "V2UserFacingFunctionalityFeatureRequestCompletedDetails",
  "V2UserFacingFunctionalityFinalizeQuestionnaireResponse",
  "V2UserFacingFunctionalityFlfContextDetail",
  "V2UserFacingFunctionalityGetApiPolicyBannerContextResponse",
  "V2UserFacingFunctionalityGetFeatureConfigurationIntentByFeatureMutationIdResponse",
  "V2UserFacingFunctionalityGetFeatureConfigurationIntentLogsResponse",
  "V2UserFacingFunctionalityGetFeatureConfigurationIntentQuestionnaireResponse",
  "V2UserFacingFunctionalityGetFeatureConfigurationIntentResponse",
  "V2UserFacingFunctionalityGetFunctionalityResponse",
  "V2UserFacingFunctionalityInitialEnabledStatesEntry",
  "V2UserFacingFunctionalityListActiveFeatureConfigurationIntentsResponse",
  "V2UserFacingFunctionalityListFunctionalitiesResponse",
  "V2UserFacingFunctionalityListFunctionalityAuditLogsResponse",
  "V2UserFacingFunctionalityQuestionGroup",
  "V2UserFacingFunctionalityQuestionnaireSelectedOptionData",
  "V2UserFacingFunctionalityRenderedActionPlanStep",
  "V2UserFacingFunctionalityRenderedStepUiElement",
  "V2UserFacingFunctionalitySandboxStatus",
  "V2UserFacingFunctionalitySendPolicyFeedbackResponse",
  "V2UserFacingFunctionalityTargetStates",
  "V2UserFacingFunctionalityToggleFunctionalityResponse",
  "V2UserFacingFunctionalityUpdateQuestionnaireResponse",
  "V2UserGroupsCompartmentRoleAssignment",
  "V2UserGroupsListUserGroupMembersResponse",
  "V2UserGroupsListUserGroupsResponse",
  "V2UserGroupsRetrieveUserGroupResponse",
  "V2UserGroupsRetrieveUserGroupStateResponse",
  "V2UserGroupsRole",
  "V2UserGroupsSetRoleAssignmentsForUserGroupResponse",
  "V2UserInviteCheckUserInviteEligibilityResponse",
  "V2UserInviteInviteUsersToCompartmentsResponse",
  "V2UserInviteRevokeUserInvitesResponse",
  "V2UserInviteUserInviteEligibilityStatus",
  "V2UserInviteUserInviteStatus",
  "V2UserLevelExperimentCancelUserLevelExperimentResponse",
  "V2UserLevelExperimentCancelUserLevelExperimentV2Response",
  "V2UserLevelExperimentListUserLevelExperimentsResponse",
  "V2UserVisiblePermissionListUserVisiblePermissionsResponse",
  "V2UsersInteropCompartmentWithRoles",
  "V2UsersInteropGetTeamByCompartmentResponse",
  "V2UsersInteropRole",
  "V2UsersInteropTwoFactorOption",
  "V2V2ExportPlansCustomSchedule",
  "V2V2ExportPlansCustomSchedulesEntry",
  "V2V2ExportPlansPausedTable",
  "V2V2ExportPlansTableIdentifier",
  "V2V2ExportRunsListSDPTablesResponse",
  "V2V2ExportRunsListTableLoadRecordsResponse",
  "V2WebSecurityDemoTestAuthenticatedWebSecurityResponse",
  "V2WorkbenchVtwoActionableError",
  "V2WorkbenchVtwoActionableErrorGroup",
  "V2WorkbenchVtwoDataEntry",
  "V2WorkbenchVtwoDownloadExportResponse",
  "V2WorkbenchVtwoListActionableErrorsResponse",
  "V2WorkbenchVtwoListExportsResponse",
  "V2WorkbenchVtwoListRequestLogsResponse",
  "V2WorkbenchVtwoMethod",
  "V2WorkbenchVtwoRequest",
  "V2WorkbenchVtwoResponse",
  "V2WorkflowsManagementApiAction",
  "V2WorkflowsManagementApiActionResultExpression",
  "V2WorkflowsManagementApiArrayExpression",
  "V2WorkflowsManagementApiBinaryExpression",
  "V2WorkflowsManagementApiBooleanLiteral",
  "V2WorkflowsManagementApiBranchingConfig",
  "V2WorkflowsManagementApiCollectionFilterExpression",
  "V2WorkflowsManagementApiCustomActionConfig",
  "V2WorkflowsManagementApiDateTimeLiteral",
  "V2WorkflowsManagementApiDecimalLiteral",
  "V2WorkflowsManagementApiDelayDurationConfig",
  "V2WorkflowsManagementApiDelayTargetTimeConfig",
  "V2WorkflowsManagementApiDelayTimestampConfig",
  "V2WorkflowsManagementApiForEachConfig",
  "V2WorkflowsManagementApiIntegerLiteral",
  "V2WorkflowsManagementApiIterationItemExpression",
  "V2WorkflowsManagementApiMapAccessExpression",
  "V2WorkflowsManagementApiMapEntry",
  "V2WorkflowsManagementApiMapExpression",
  "V2WorkflowsManagementApiNullLiteralExpression",
  "V2WorkflowsManagementApiObjectExpression",
  "V2WorkflowsManagementApiObjectProperty",
  "V2WorkflowsManagementApiPaginatedListExpression",
  "V2WorkflowsManagementApiPaginationContinuation",
  "V2WorkflowsManagementApiPercentSplitConfig",
  "V2WorkflowsManagementApiPlatformActionConfig",
  "V2WorkflowsManagementApiPlatformActionConfigParameter",
  "V2WorkflowsManagementApiPlatformDelayConfig",
  "V2WorkflowsManagementApiPredicateInputExpression",
  "V2WorkflowsManagementApiPreviousValueExpression",
  "V2WorkflowsManagementApiPropertyAccessExpression",
  "V2WorkflowsManagementApiRedactedLiteralExpression",
  "V2WorkflowsManagementApiScriptExpression",
  "V2WorkflowsManagementApiScriptVariable",
  "V2WorkflowsManagementApiSendMerchantNotificationEmailConfig",
  "V2WorkflowsManagementApiStringLiteral",
  "V2WorkflowsManagementApiTemplateExpression",
  "V2WorkflowsManagementApiTemplateVariable",
  "V2WorkflowsManagementApiTriggerConfig",
  "V2WorkflowsManagementApiTriggerContextExpression",
  "V2WorkflowsManagementApiTriggerExtraDataExpression",
  "V2WorkflowsManagementApiTriggerPayloadExpression",
  "V2WorkflowsManagementApiUnaryExpression",
  "V2WorkflowsManagementDeleteWorkflowDraftResponse",
  "V2WorkflowsManagementRecipient",
  "V2WorkflowsManagementRootApiExpression",
  "V2WorkflowsManagementTest",
  "V2WorkflowsManagementUserDefinedSchema",
  "V2WorkflowsManagementV1Api",
  "V2WorkflowsManagementV2Api",
  "V2WorkflowsManagementWorkflowScheduleConfig",
  "V2WorkflowsManagementWorkflowScheduleRecurrenceRule",
  "V2WorkflowsManagementWorkflowScheduleSpec",
  "V2WorkflowsManagementWorkflowSchedulerPolicy",
  "V2WorkflowsPublicActionProvider",
  "V2WorkflowsPublicActivatedWorkflowDefinition",
  "V2WorkflowsPublicApiAction",
  "V2WorkflowsPublicApiActionResultExpression",
  "V2WorkflowsPublicApiArrayExpression",
  "V2WorkflowsPublicApiBinaryExpression",
  "V2WorkflowsPublicApiBooleanLiteral",
  "V2WorkflowsPublicApiBranchingConfig",
  "V2WorkflowsPublicApiCollectionFilterExpression",
  "V2WorkflowsPublicApiCustomActionConfig",
  "V2WorkflowsPublicApiDateTimeLiteral",
  "V2WorkflowsPublicApiDecimalLiteral",
  "V2WorkflowsPublicApiDelayDurationConfig",
  "V2WorkflowsPublicApiDelayTargetTimeConfig",
  "V2WorkflowsPublicApiDelayTimestampConfig",
  "V2WorkflowsPublicApiEventResourceSchema",
  "V2WorkflowsPublicApiForEachConfig",
  "V2WorkflowsPublicApiIntegerLiteral",
  "V2WorkflowsPublicApiIterationItemExpression",
  "V2WorkflowsPublicApiMapAccessExpression",
  "V2WorkflowsPublicApiMapEntry",
  "V2WorkflowsPublicApiMapExpression",
  "V2WorkflowsPublicApiNullLiteralExpression",
  "V2WorkflowsPublicApiObjectExpression",
  "V2WorkflowsPublicApiObjectProperty",
  "V2WorkflowsPublicApiPaginatedListExpression",
  "V2WorkflowsPublicApiPaginationContinuation",
  "V2WorkflowsPublicApiPercentSplitConfig",
  "V2WorkflowsPublicApiPlatformActionConfig",
  "V2WorkflowsPublicApiPlatformActionConfigParameter",
  "V2WorkflowsPublicApiPlatformDelayConfig",
  "V2WorkflowsPublicApiPredicateInputExpression",
  "V2WorkflowsPublicApiPreviousValueExpression",
  "V2WorkflowsPublicApiPropertyAccessExpression",
  "V2WorkflowsPublicApiRedactedLiteralExpression",
  "V2WorkflowsPublicApiScriptExpression",
  "V2WorkflowsPublicApiScriptVariable",
  "V2WorkflowsPublicApiSendMerchantNotificationEmailConfig",
  "V2WorkflowsPublicApiStringLiteral",
  "V2WorkflowsPublicApiTemplateExpression",
  "V2WorkflowsPublicApiTemplateVariable",
  "V2WorkflowsPublicApiTriggerConfig",
  "V2WorkflowsPublicApiTriggerContextExpression",
  "V2WorkflowsPublicApiTriggerExtraDataExpression",
  "V2WorkflowsPublicApiTriggerPayloadExpression",
  "V2WorkflowsPublicApiUnaryExpression",
  "V2WorkflowsPublicDashboardActivationSummary",
  "V2WorkflowsPublicDashboardDeserializeWorkflowDefinitionDeepLinkResponse",
  "V2WorkflowsPublicDashboardGenerateVersionSummaryResponse",
  "V2WorkflowsPublicDashboardListActionsResponse",
  "V2WorkflowsPublicDashboardListResourcesResponse",
  "V2WorkflowsPublicDashboardListStripeApiVersionsResponse",
  "V2WorkflowsPublicDashboardListTriggersResponse",
  "V2WorkflowsPublicDashboardListWorkflowRunStepsResponse",
  "V2WorkflowsPublicDashboardListWorkflowRunsResponse",
  "V2WorkflowsPublicDashboardListWorkflowsResponse",
  "V2WorkflowsPublicDashboardParseToPropertiesResponse",
  "V2WorkflowsPublicDashboardRetrieveWorkflowResponse",
  "V2WorkflowsPublicDashboardRetrieveWorkflowRunResponse",
  "V2WorkflowsPublicDashboardRetrieveWorkflowVersionResponse",
  "V2WorkflowsPublicDashboardSerializeWorkflowDefinitionDeepLinkResponse",
  "V2WorkflowsPublicDashboardStripeApiVersion",
  "V2WorkflowsPublicDashboardUserDetails",
  "V2WorkflowsPublicDashboardWorkflowRunTrigger",
  "V2WorkflowsPublicDraftWorkflowDefinition",
  "V2WorkflowsPublicEnumSchema",
  "V2WorkflowsPublicEventResourcePayloadSchema",
  "V2WorkflowsPublicEventTrigger",
  "V2WorkflowsPublicFailedDetails",
  "V2WorkflowsPublicFlattenedPropertySchema",
  "V2WorkflowsPublicFlattenedPropertySchemaShape",
  "V2WorkflowsPublicListWorkflowRunsResponse",
  "V2WorkflowsPublicListWorkflowVersionHistoryResponse",
  "V2WorkflowsPublicListWorkflowVersionsResponse",
  "V2WorkflowsPublicListWorkflowsResponse",
  "V2WorkflowsPublicManual",
  "V2WorkflowsPublicMonetarySchema",
  "V2WorkflowsPublicParameter",
  "V2WorkflowsPublicParseWarning",
  "V2WorkflowsPublicPayloadSchema",
  "V2WorkflowsPublicRecipient",
  "V2WorkflowsPublicResourcePayloadSchema",
  "V2WorkflowsPublicRetrieveAllActionSchemasResponse",
  "V2WorkflowsPublicRetrieveCustomActionSchemaWithFormStateResponse",
  "V2WorkflowsPublicRetrieveWorkflowActionSchemasResponse",
  "V2WorkflowsPublicRootApiExpression",
  "V2WorkflowsPublicRootApiPropertySchemaShape",
  "V2WorkflowsPublicStripeAPIProviderDetails",
  "V2WorkflowsPublicTest",
  "V2WorkflowsPublicUserDefinedPayloadSchema",
  "V2WorkflowsPublicUserDefinedSchema",
  "V2WorkflowsPublicV1Api",
  "V2WorkflowsPublicV2Api",
  "V2WorkflowsPublicWorkflowApiCallConfig",
  "V2WorkflowsPublicWorkflowBranchCase",
  "V2WorkflowsPublicWorkflowBranchConfig",
  "V2WorkflowsPublicWorkflowCustomActionConfig",
  "V2WorkflowsPublicWorkflowDefinitionEventTrigger",
  "V2WorkflowsPublicWorkflowDefinitionManualTrigger",
  "V2WorkflowsPublicWorkflowDefinitionTrigger",
  "V2WorkflowsPublicWorkflowDelayConfig",
  "V2WorkflowsPublicWorkflowDelayDurationConfig",
  "V2WorkflowsPublicWorkflowForEachConfig",
  "V2WorkflowsPublicWorkflowRunStatusDetails",
  "V2WorkflowsPublicWorkflowRunStatusTransitions",
  "V2WorkflowsPublicWorkflowRunTrigger",
  "V2WorkflowsPublicWorkflowScheduleConfig",
  "V2WorkflowsPublicWorkflowScheduleRecurrenceRule",
  "V2WorkflowsPublicWorkflowScheduleSpec",
  "V2WorkflowsPublicWorkflowSchedulerPolicy",
  "V2WorkflowsPublicWorkflowTrigger",
  "V2WorkflowsPublicWorkflowTriggerInputSchema",
  "V2WorkspacesBankAccountsCapabilityResource",
  "V2WorkspacesCapabilityResource",
  "V2WorkspacesCapabilityStatusDetail",
  "V2WorkspacesCardCreatorCapabilitiesResource",
  "V2WorkspacesCardCreatorConfigResource",
  "V2WorkspacesConsumerStorageCapabilitiesResource",
  "V2WorkspacesConsumerStorageFlowCapabilitiesResource",
  "V2WorkspacesCoreFieldsDefaultsResource",
  "V2WorkspacesFeatureStatusDetail",
  "V2WorkspacesGetCoreFieldsForWorkspaceResponse",
  "V2WorkspacesGrossSettlementResource",
  "V2WorkspacesListFeaturesForWorkspaceResponse",
  "V2WorkspacesMerchantConfigResource",
  "V2WorkspacesOutboundPaymentsCapabilitiesResource",
  "V2WorkspacesOutboundTransfersCapabilitiesResource",
  "V2WorkspacesPayoutMethodsEntry",
  "V2WorkspacesReceivedCreditsCapabilitiesResource",
  "V2WorkspacesReceivedDebitsCapabilitiesResource",
  "V2WorkspacesRecipientCapabilitiesResource",
  "V2WorkspacesRecipientConfigResource",
  "V2WorkspacesRetrieveCardCreatorConfigForWorkspaceResponse",
  "V2WorkspacesRetrieveMerchantConfigForWorkspaceResponse",
  "V2WorkspacesRetrieveRecipientConfigForWorkspaceResponse",
  "V2WorkspacesRetrieveStorerConfigForWorkspaceResponse",
  "V2WorkspacesStorerCapabilitiesResource",
  "V2WorkspacesStorerConfigResource",
  "V2WorkspacesStripeBalanceCapabilityResource",
  "V2WorkspacesUpdateMerchantConfigForWorkspaceResponse"
]